/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(111), __webpack_require__(116), __webpack_require__(112), __webpack_require__(3), __webpack_require__(9), __webpack_require__(113),
	    __webpack_require__(1), __webpack_require__(118), __webpack_require__(120), __webpack_require__(122), __webpack_require__(123), __webpack_require__(124)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(namespace, bootstrap, config, extend, util, formatting, validation, instanceRegistry, ConfigEvaluator, meta, componentInit, context) {
	    'use strict';

	    function createAsterix() {
	        if (util.isEmptyObject(morningstar.asterix)) {
	            morningstar.asterix = {
	                register: namespace.register,
	                reset: namespace.reset,
	                noConflict: namespace.noConflict,
	                config: config,
	                extend: extend,
	                util: util,
	                formatting: formatting,
	                validation: validation,
	                instanceRegistry: instanceRegistry,
	                ConfigEvaluator: ConfigEvaluator,
	                bootstrap: bootstrap,
	                meta: meta,
	                context: context
	            };
	        }
	    }

	    createAsterix();
	    morningstar.initComponent = componentInit.init;

	    return {
	        createAsterix: createAsterix
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    var validation = __webpack_require__(2);

	    __webpack_require__(105);
	    __webpack_require__(106);
	    __webpack_require__(107);
	    __webpack_require__(108);
	    __webpack_require__(109);
	    __webpack_require__(110);

	    return validation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(extend, util) {
	    'use strict';
	    var validators = {},
	        baseValidators = {
	            'custom': {
	                __requires: [{
	                    name: 'execute',
	                    type: 'function'
	                }]
	            },
	            'regex': {
	                __requires: [{
	                    name: 'pattern',
	                    type: 'regex',
	                    transformType: 'string',
	                    transform: function(str) {
	                        return new RegExp(str);
	                    }
	                }],
	                execute: function(val, options) {
	                    return this.pattern.test(val);
	                }
	            }
	        };

	    var isValidType = function isValidType(obj, type) {
	        switch (type) {
	            case 'regex':
	                return util.isRegex(obj);
	            case 'function':
	                return util.isFunction(obj);
	            case 'string':
	                return util.isString(obj);
	        }

	        return false;
	    };

	    var addValidationRule = function addValidationRule(key, validator) {
	        if (!validator.type) {
	            throw new Error('addValidationRule requires type');
	        }

	        if (!util.isString(key) && !util.isArray(key)) {
	            throw new Error('addValidationRule requires a string or array key');
	        }

	        if (!baseValidators[validator.type]) {
	            throw new Error('Unrecognized validator type: ' + validator.type);
	        }

	        var baseValidator = extend({}, baseValidators[validator.type]);

	        util.each(baseValidator.__requires, function(requirement, prop) {
	            var value = validator[requirement.name];
	            if (!validator.hasOwnProperty(requirement.name) || !isValidType(value, requirement.type)) {
	                if (!isValidType(value, requirement.type) && isValidType(value, requirement.transformType)) {
	                    validator[requirement.name] = requirement.transform(value);
	                } else {
	                    throw new Error('baseValidator requires property: ' + requirement.name + ' of type ' +
	                        requirement.type);
	                }
	            }
	        });

	        delete baseValidator.__requires;

	        validator = extend(baseValidator, validator);

	        if (util.isArray(key)) {
	            for (var i in key) {
	                var k = key[i];
	                if (validators.hasOwnProperty(k)) {
	                    continue;
	                }
	                validators[k] = validator;
	            }
	        } else {
	            if (validators.hasOwnProperty(key)) {
	                return;
	            }
	            validators[key] = validator;
	        }
	    };

	    var addCustomValidationRule = function addCustomValidationRule(key, execute) {
	        addValidationRule(key, {
	            type: 'custom',
	            execute: execute
	        });
	    };

	    var getValidatorForType = function getValidatorForType(type) {
	        var validator = validators.hasOwnProperty(type) ? validators[type] : null;
	        if (validator === null) {
	            throw new Error('Invalid validator key: ' + type);
	        }

	        return validator;
	    };

	    var shouldRun = function shouldRun(validator, isFalsy) {
	        return isFalsy === false || validator.runFalsy === true;
	    };

	    var validateDataType = function validateDataType(dataType, val) {
	        switch (dataType) {
	            case 'number':
	                return util.isNumber(val);
	            case 'string':
	                return util.isString(val);
	            case 'date':
	                return util.isDate(val);
	            default:
	                throw new Error('Unrecognized data type: ' + dataType);
	        }
	    };

	    var getValidator = function getValidator(options) {
	        options = options || {};
	        if ((!options.rules || !util.isPlainObject(options.rules) || Object.keys(options.rules).length === 0) &&
	            !util.isString(options.dataType)) {
	            return null;
	        }

	        var parsed = options.path ? util.parse(options.path) : null;

	        return {
	            validate: function validate(val) {
	                val = parsed ? parsed(val) : val;

	                var results = {},
	                    isEmpty = val == null || val === '';

	                // run data type validation first and return if it fails (don't validate the data type of empty values)
	                if (util.isString(options.dataType) && isEmpty === false) {
	                    results.dataType = {
	                        rule: {
	                            type: 'dataType',
	                            labelKey: options.dataTypeLabelKey || ('fieldInvalidDatatype' + util.string.firstUpperCase(options.dataType))
	                        },
	                        returnValue: validateDataType(options.dataType, val)
	                    };
	                    if (!results.dataType.returnValue) {
	                        return results;
	                    }
	                }

	                util.each(options.rules, function(rule, prop) {
	                    var validator = getValidatorForType(rule.type);

	                    // skip validations that don't validate non-empty values
	                    if (!shouldRun(validator, isEmpty)) {
	                        return;
	                    }

	                    if (results[prop]) {
	                        throw new Error('Multiple occurrences of the same rule key: ' + prop);
	                    }

	                    results[prop] = {
	                        rule: rule,
	                        returnValue: validator.execute(val, rule)
	                    };
	                });

	                return results;
	            }
	        };
	    };

	    return {
	        addValidationRule: addValidationRule,
	        addCustomValidationRule: addCustomValidationRule,
	        getValidator: getValidator
	    };

	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(5),
	    __webpack_require__(6)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(isFunction, isArray, isPlainObject) {

	    /**
	     * Packaged javascript object extends from jQuery ($.extend) with the notable exception
	     * that $.extend({}) does not extend the morningstar.asterix or morningstar namespace.
	     *
	     * @class
	     * @param {*|boolean} [target|deep copy] [object to extend or flag for deep copy]
	     * @param {*} [target] [target if deep copy specified]
	     * @param {...*} [sources] [sources to extend target with, may be multiple]
	     * @return {object} extended object
	     * @author dcolli1
	     */
	    'use strict';

	    function extend() {
	        var src, copyIsArray, copy, name, options, clone,
	            target = arguments[0] || {},
	            i = 1,
	            length = arguments.length,
	            deep = false;

	        if (length === 1) {
	            return;
	        }

	        // Handle a deep copy situation
	        if (typeof target === 'boolean') {
	            deep = target;
	            target = arguments[1] || {};
	            // skip the boolean and the target
	            i = 2;
	        }

	        // Handle case when target is a string or something (possible in deep copy)
	        if (typeof target !== 'object' && !isFunction(target)) {
	            target = {};
	        }

	        for (; i < length; i++) {
	            // Only deal with non-null/undefined values
	            if ((options = arguments[i]) != null) {
	                // extend the base object
	                for (name in options) {
	                    src = target[name];
	                    copy = options[name];

	                    // Prevent never-ending loop
	                    if (target === copy) {
	                        continue;
	                    }

	                    // Recurse if we're merging plain objects or arrays
	                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
	                        if (copyIsArray) {
	                            copyIsArray = false;
	                            clone = src && isArray(src) ? src : [];
	                        } else {
	                            clone = src && isPlainObject(src) ? src : {};
	                        }

	                        // Never move original objects, clone them
	                        target[name] = extend(deep, clone, copy);

	                        // Don't bring in undefined values
	                    } else if (copy !== undefined) {
	                        target[name] = copy;
	                    }
	                }
	            }
	        }

	        // Return the modified object
	        return target;
	    }

	    return extend;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Determines if a given object is a function.
	     * @function module:morningstar.asterix.util/isFunction
	     * @param  {any}  object any type of object
	     * @return {Boolean} true if function, false if not
	     */
	    var isFunction = function(object) {
	        return typeof object === 'function';
	    };

	    return isFunction;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Determines if a given object is an Array.
	     * @function module:morningstar.asterix.util/isArray
	     * @param  {any}  object any type of object
	     * @return {Boolean} true if array, false if not
	     */
	    var isArray = Array.isArray || function(object) {
	            return object instanceof Array;
	            //return typeof object === 'array';
	        };

	    return isArray;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7),
	    __webpack_require__(8)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function(getPrototype, isWindow) {
	    'use strict';
	    /**
	     * Determines if a given object is a plain object.
	     * @function module:morningstar.asterix.util/isPlainObject
	     * @param  {any}  object any type of object
	     * @return {Boolean} true if plain object, false if not
	     */
	    var isPlainObject = function(object) {
	        if (!object || object.nodeType) {
	            return false;
	        }

	        return typeof object === 'object' && getPrototype(object) === Object.prototype;
	    };

	    return isPlainObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Retrieves an object's prototype
	     * @function module:morningstar.asterix.util/getPrototype
	     * @param {any} obj object any type of object
	     * @return {Boolean} true if function, false if not
	     */
	    var getPrototype = function(obj) {
	        return obj.__proto__ || obj.prototype || (obj.constructor && obj.constructor.prototype) || Object.prototype;
	    };

	    return getPrototype;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    /**
	     * Determines if a given object is the Window object.
	     * @function module:morningstar.asterix.util/isWindow
	     * @param  {any}  object of any type
	     * @return {Boolean} true if Window, false if not
	     */
	    var isWindow = function(object) {
	        return (object !== null && object === object.window) || (window && object === window);
	    };

	    return isWindow;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return {
	        isFunction: __webpack_require__(4),
	        isArray: __webpack_require__(5),
	        isBoolean: __webpack_require__(10),
	        isPlainObject: __webpack_require__(6),
	        isWindow: __webpack_require__(8),
	        isDate: __webpack_require__(11),
	        isEmptyObject: __webpack_require__(12),
	        isNumber: __webpack_require__(13),
	        isString: __webpack_require__(14),
	        isRegex: __webpack_require__(15),
	        isUndefined: __webpack_require__(16),
	        isObject: __webpack_require__(17),
	        isDomElement: __webpack_require__(18),
	        getPrototype: __webpack_require__(7),
	        noop: __webpack_require__(19),
	        url: __webpack_require__(20),
	        parse: __webpack_require__(21),
	        each: __webpack_require__(22),
	        filter: __webpack_require__(23),
	        any: __webpack_require__(24),
	        has: __webpack_require__(25),
	        toString: __webpack_require__(26),
	        isEqual: __webpack_require__(27),
	        componentPath: __webpack_require__(28),
	        string: __webpack_require__(68),
	        merge: __webpack_require__(29),
	        map: __webpack_require__(69),
	        css: __webpack_require__(98),
	        intlNumberFormat: __webpack_require__(99),
	        intlDateFormat: __webpack_require__(101),
	        log: __webpack_require__(102),
	        field: __webpack_require__(103),
	        fastdom: __webpack_require__(104)
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    function isBoolean(obj) {
	        return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	    };

	    return isBoolean;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    function isDate(value) {
	        return Object.prototype.toString.call(value) === '[object Date]';
	    }

	    return isDate;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Determines if a variable object is an empty object {}.
	     * @function module:morningstar.asterix.util/isEmptyObject
	     * @param  {any}  object any type of object
	     * @return {Boolean} true if object that is empty, otherwise false
	     */
	    var isEmptyObject = function(object) {
	        var t;
	        for (t in object) {
	            if (object.hasOwnProperty(t)) {
	                return !1;
	            }
	        }
	        return !0;
	    };

	    return isEmptyObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    function isNumber(value) {
	        return typeof value === 'number';
	    }

	    return isNumber;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return function(object) {
	        return typeof object === 'string';
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return function(object) {
	        return object instanceof RegExp;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return function(obj) {
	        return obj === void 0;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Determines if a variable object is an object.
	     * @function module:morningstar.asterix.util/isObject
	     * @param  {any}  object any type of object
	     * @return {Boolean} true if object that is not null, otherwise false
	     */
	    var isObject = function(object) {
	        return typeof object === 'object' && object !== null;
	    };

	    return isObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    /**
	     * Determines if a given object is a DOM element.
	     * @function module:morningstar.asterix.util/isDomElement
	     * @param  {any}  any type
	     * @return {Boolean} true if DOM element, false if not
	     */
	    var isDomElement = function(elm) {

	        return elm instanceof HTMLElement;
	    };

	    return isDomElement;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return function noop() {

	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    var parameterize = function(urlTemplate, parameters) {
	        var url = urlTemplate;
	        if (url && parameters) {
	            url = url.replace(/\{\{\s*(.*?)\s*\}\}/g, function(match, group) {
	                if (parameters.hasOwnProperty(group)) {
	                    return parameters[group];
	                }
	                return match;
	            });
	        }

	        return url;
	    };

	    return {
	        parameterize: parameterize
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function(each, isUndefined) {
	    'use strict';
	    var parse = function(expression) {
	        var parts = expression.split('.'),
	            body = [];
	        this.parts = parts;

	        body.push('var curr = obj;');
	        each(parts, function(part) {
	            body.push('if (!curr) return curr;');
	            body.push('curr = curr["' + part + '"];');
	        });

	        body.push('return curr;');

	        var ret = new Function('obj', body.join(''));
	        ret.assign = function(obj, value) {
	            if (!obj) {
	                throw new Error('util.parse.assign expects its first argument to be an object');
	            }

	            var curr = obj,
	                prevCurr, currPart;
	            each(parts, function(part) {
	                currPart = part;
	                prevCurr = curr;
	                curr = curr[part];
	                if (isUndefined(curr) || curr === null) {
	                    prevCurr[part] = {};
	                    curr = prevCurr[part];
	                }
	            });

	            if (!prevCurr || !currPart) {
	                return;
	            }

	            prevCurr[currPart] = value;
	        };

	        return ret;
	    };

	    return parse;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    var each = function(obj, iteratee, context) {
	        if (obj == null) {
	            return obj;
	        }
	        //iteratee = optimizeCb(iteratee, context);
	        var i, length = obj.length;
	        if (length === +length) {
	            for (i = 0; i < length; i++) {
	                iteratee(obj[i], i, obj);
	            }
	        } else {
	            var keys = Object.keys(obj);
	            for (i = 0, length = keys.length; i < length; i++) {
	                iteratee(obj[keys[i]], keys[i], obj);
	            }
	        }
	        return obj;
	    };

	    return each;

	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function(each) {
	    'use strict';

	    var filter = function(obj, predicate) {
	        var results = [];
	        each(obj, function(value, index, list) {
	            if (predicate(value, index, list)) {
	                results.push(value);
	            }
	        });

	        return results;
	    };

	    return filter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArray) {
	    'use strict';

	    var any = function(obj, predicate) {
	        var keys = !isArray(obj) && Object.keys(obj),
	            length = (keys || obj).length;
	        for (var index = 0; index < length; index++) {
	            var currentKey = keys ? keys[index] : index;
	            if (predicate(obj[currentKey], currentKey, obj)) {
	                return true;
	            }
	        }

	        return false;
	    };

	    return any;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    var has = function(obj, key) {
	        return obj != null && hasOwnProperty.call(obj, key);
	    };

	    return has;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * To fix an IE error:
	 * http://stackoverflow.com/questions/19321938/invalid-calling-object-error-in-ie
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	    return ({}).toString.call.bind(({}).toString);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(25), __webpack_require__(26), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function (isFunction, has, toString, each) {
	    'use strict';

	    // Internal recursive comparison function for `isEqual`.
	    var eq, deepEq, getKeys;
	    eq = function (a, b, aStack, bStack) {
	        // Identical objects are equal. `0 === -0`, but they aren't identical.
	        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	        if (a === b) {
	            return a !== 0 || 1 / a === 1 / b;
	        }
	        // A strict comparison is necessary because `null == undefined`.
	        if (a == null || b == null) {
	            return a === b;
	        }
	        // `NaN`s are equivalent, but non-reflexive.
	        if (a !== a) {
	            return b !== b;
	        }
	        // Exhaust primitive checks
	        var type = typeof a;
	        if (type === 'function' && typeof b === 'function') {
	            return true;
	        }

	        if (type !== 'function' && type !== 'object' && typeof b !== 'object') {
	            return false;
	        }
	        return deepEq(a, b, aStack, bStack);
	    };

	    // Internal recursive comparison function for `isEqual`.
	    deepEq = function (a, b, aStack, bStack) {
	        // Compare `[[Class]]` names.
	        var className = toString(a);
	        if (className !== toString(b)) {
	            return false;
	        }
	        switch (className) {
	            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	            case '[object RegExp]':
	            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	            case '[object String]':
	                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	                // equivalent to `new String("5")`.
	                return '' + a === '' + b;
	            case '[object Number]':
	                // `NaN`s are equivalent, but non-reflexive.
	                // Object(NaN) is equivalent to NaN
	                if (+a !== +a) {
	                    return +b !== +b;
	                }
	                // An `egal` comparison is performed for other numeric values.
	                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	            case '[object Date]':
	            case '[object Boolean]':
	                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	                // millisecond representations. Note that invalid dates with millisecond representations
	                // of `NaN` are not equivalent.
	                return +a === +b;
	        }

	        var areArrays = className === '[object Array]';
	        if (!areArrays) {
	            if (typeof a != 'object' || typeof b != 'object') {
	                return false;
	            }

	            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	            // from different frames are.
	            var aCtor = a.constructor, bCtor = b.constructor;
	            if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor &&
	                isFunction(bCtor) && bCtor instanceof bCtor) &&
	                ('constructor' in a && 'constructor' in b)) {
	                return false;
	            }
	        }
	        // Assume equality for cyclic structures. The algorithm for detecting cyclic
	        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

	        // Initializing stack of traversed objects.
	        // It's done here since we only need them for objects and arrays comparison.
	        aStack = aStack || [];
	        bStack = bStack || [];
	        var length = aStack.length;
	        while (length--) {
	            // Linear search. Performance is inversely proportional to the number of
	            // unique nested structures.
	            if (aStack[length] === a) {
	                return bStack[length] === b;
	            }
	        }

	        // Add the first object to the stack of traversed objects.
	        aStack.push(a);
	        bStack.push(b);

	        // Recursively compare objects and arrays.
	        if (areArrays) {
	            // Compare array lengths to determine if a deep comparison is necessary.
	            var aKeys = getKeys(a),
	                bKeys = getKeys(b);
	            if (aKeys.length !== bKeys.length) {
	                return false;
	            }

	            // Deep compare the contents
	            for (var key in aKeys) {
	                key = aKeys[key];
	                if (!eq(a[key], b[key], aStack, bStack)) {
	                    return false;
	                }
	            }
	        } else {
	            // Deep compare objects.
	            var keys = getKeys(a), key;
	            length = keys.length;
	            // Ensure that both objects contain the same number of properties before comparing deep equality.
	            if (getKeys(b).length !== length) {
	                return false;
	            }
	            while (length--) {
	                // Deep compare each member
	                key = keys[length];
	                if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) {
	                    return false;
	                }
	            }
	        }
	        // Remove the first object from the stack of traversed objects.
	        aStack.pop();
	        bStack.pop();
	        return true;
	    };

	    getKeys = function(obj) {
	        var returnKeys = [];

	        if (obj) {
	            for (var index = 0; index < Object.keys(obj).length; index++) {
	                var key = Object.keys(obj)[index];
	                if (key.indexOf('$') !== 0) {
	                    returnKeys.push(key);
	                }
	            }
	        }

	        return returnKeys;
	    };

	    // Perform a deep comparison to check if two objects are equal.
	    var isEqual = function (a, b) {
	        return eq(a, b);
	    };

	    return isEqual;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22), __webpack_require__(29)], __WEBPACK_AMD_DEFINE_RESULT__ = function(each, merge) {
	    'use strict';

	    return {
	        resolve: resolve,
	        relative: relative,
	        assignInstance: assignInstance
	    };

	    function assignInstance(modulePath, appConfig, defaultConfig, type, instanceConfig, cb) {
	        var curr = appConfig;
	        var parts = modulePath.split('.');
	        var addAt;
	        each(parts, function(part, i) {
	            if (curr.components && curr.components[part]) {
	                curr = curr.components[part];
	            } else if (curr.type && defaultConfig[curr.type] &&
	                defaultConfig[curr.type].components[part]) {
	                curr = defaultConfig[curr.type].components[part];
	            } else {
	                if (i === parts.length - 1) {
	                    if (part.indexOf('[') >= 0) {
	                        part = part.substring(0, part.lastIndexOf('['));
	                        if (curr.components && curr.components[part]) {
	                            instanceConfig = merge({}, defaultConfig && defaultConfig[curr.type] && defaultConfig[curr.type].components ? defaultConfig[curr.type].components[part] : {}, curr.components[part], instanceConfig);
	                        } else if (defaultConfig[curr.type] && defaultConfig[curr.type].components && defaultConfig[curr.type].components[part]) {
	                            instanceConfig = merge({}, defaultConfig[curr.type].components[part], instanceConfig);
	                        }
	                    }

	                    if (!curr.components) {
	                        curr.components = {};
	                    }

	                    addAt = curr.components;
	                } else {
	                    throw new Error('(util) Could not assign instance dynamically because a parent instance was not initialized: ' +
	                        part);
	                }
	            }
	        });

	        if (addAt) {
	            instanceConfig = instanceConfig || {components: {}};
	            instanceConfig.type = type;
	            addAt[parts[parts.length - 1]] = instanceConfig;
	        }

	        if (cb) {
	            cb(modulePath);
	        }
	    }

	    function resolve(currentPath, relativePath) {
	        if (!relativePath) {
	            return currentPath;
	        }

	        if (currentPath == null) {
	            throw new Error('currentPath must have a value');
	        }

	        var currentSegments = currentPath.split('.');
	        if (currentSegments[0] === '') {
	            currentSegments.splice(0, 1);
	        }

	        var relativeSegments = relativePath.split('.');
	        var resultingSegments = [];
	        var hasSpecifiedSegment = false;
	        each(relativeSegments, function(segment) {
	            if (segment === '_') {
	                if (hasSpecifiedSegment) {
	                    throw new Error('Invalid relative path: ' + relativePath);
	                } else {
	                    if (!currentSegments.pop()) {
	                        throw new Error('Invalid relative path lookup: ' + currentPath + ', ' + relativePath);
	                    }
	                }
	            } else {
	                resultingSegments.push(segment);
	                hasSpecifiedSegment = true;
	            }
	        });

	        return currentSegments.join('.') + (currentSegments.length && resultingSegments.length ? '.' : '') + resultingSegments.join('.');
	    }

	    function relative(from, to) {
	        var s1 = !from ? [] : from.split('.'),
	            s2 = !to ? [] : to.split('.');
	        var up = [], down = [], noConflicts = true;
	        for (var i = 0; i < Math.max(s1.length, s2.length); i++) {
	            if (s1.length > i && s2.length > i) {
	                if (s1[i] == s2[i] && noConflicts) {
	                    continue;
	                } else {
	                    up.push('_');
	                    down.push(s2[i]);
	                    noConflicts = false;
	                }
	            } else if (s1.length > i) {
	                up.push('_');
	            } else if (s2.length > i) {
	                down.push(s2[i]);
	            }
	        }

	        return up.concat(down).join('.');
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArray) {
	    'use strict';
	    var _ = __webpack_require__(30);
	    return _.merge;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(49), __webpack_require__(51), __webpack_require__(67)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys, keysIn, merge, pairs) {
	  return {
	    'keys': keys,
	    'keysIn': keysIn,
	    'merge': merge,
	    'pairs': pairs
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(38), __webpack_require__(35), __webpack_require__(45), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(getNative, isArrayLike, isObject, shimKeys, support) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /* Native method references for those with the same name as other `lodash` methods. */
	  var nativeKeys = getNative(Object, 'keys');

	  /**
	   * Creates an array of the own enumerable property names of `object`.
	   *
	   * **Note:** Non-object values are coerced to objects. See the
	   * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the array of property names.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.keys(new Foo);
	   * // => ['a', 'b'] (iteration order is not guaranteed)
	   *
	   * _.keys('hi');
	   * // => ['0', '1']
	   */
	  var keys = !nativeKeys ? shimKeys : function(object) {
	    var Ctor = object == null ? undefined : object.constructor;
	    if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	        (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) {
	      return shimKeys(object);
	    }
	    return isObject(object) ? nativeKeys(object) : [];
	  };

	  return keys;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isNative) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * Gets the native function at `key` of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the method to get.
	   * @returns {*} Returns the function if it's native, else `undefined`.
	   */
	  function getNative(object, key) {
	    var value = object == null ? undefined : object[key];
	    return isNative(value) ? value : undefined;
	  }

	  return getNative;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(36), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isFunction, isHostObject, isObjectLike) {

	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to resolve the decompiled source of functions. */
	  var fnToString = Function.prototype.toString;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /** Used to detect if a method is native. */
	  var reIsNative = RegExp('^' +
	    fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	  );

	  /**
	   * Checks if `value` is a native function.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	   * @example
	   *
	   * _.isNative(Array.prototype.push);
	   * // => true
	   *
	   * _.isNative(_);
	   * // => false
	   */
	  function isNative(value) {
	    if (value == null) {
	      return false;
	    }
	    if (isFunction(value)) {
	      return reIsNative.test(fnToString.call(value));
	    }
	    return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	  }

	  return isNative;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isObject) {

	  /** `Object#toString` result references. */
	  var funcTag = '[object Function]';

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /**
	   * Checks if `value` is classified as a `Function` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   *
	   * _.isFunction(/abc/);
	   * // => false
	   */
	  function isFunction(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in older versions of Chrome and Safari which return 'function' for regexes
	    // and Safari 8 which returns 'object' for typed array constructors.
	    return isObject(value) && objToString.call(value) == funcTag;
	  }

	  return isFunction;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(1);
	   * // => false
	   */
	  function isObject(value) {
	    // Avoid a V8 JIT bug in Chrome 19-20.
	    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	    var type = typeof value;
	    return !!value && (type == 'object' || type == 'function');
	  }

	  return isObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  var isHostObject = (function() {
	    try {
	      Object({ 'toString': 0 } + '');
	    } catch(e) {
	      return function() { return false; };
	    }
	    return function(value) {
	      // IE < 9 presents many host objects as `Object` objects that can coerce
	      // to strings despite having improperly defined `toString` methods.
	      return typeof value.toString != 'function' && typeof (value + '') == 'string';
	    };
	  }());

	  return isHostObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }

	  return isObjectLike;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(39), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_RESULT__ = function(getLength, isLength) {

	  /**
	   * Checks if `value` is array-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	   */
	  function isArrayLike(value) {
	    return value != null && isLength(getLength(value));
	  }

	  return isArrayLike;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(40)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseProperty) {

	  /**
	   * Gets the "length" property value of `object`.
	   *
	   * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	   * that affects Safari on at least iOS 8.1-8.3 ARM64.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {*} Returns the "length" value.
	   */
	  var getLength = baseProperty('length');

	  return getLength;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(toObject) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : toObject(object)[key];
	    };
	  }

	  return baseProperty;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(35), __webpack_require__(42), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isObject, isString, support) {

	  /**
	   * Converts `value` to an object if it's not one.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {Object} Returns the object.
	   */
	  function toObject(value) {
	    if (support.unindexedChars && isString(value)) {
	      var index = -1,
	          length = value.length,
	          result = Object(value);

	      while (++index < length) {
	        result[index] = value.charAt(index);
	      }
	      return result;
	    }
	    return isObject(value) ? value : Object(value);
	  }

	  return toObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isObjectLike) {

	  /** `Object#toString` result references. */
	  var stringTag = '[object String]';

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /**
	   * Checks if `value` is classified as a `String` primitive or object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isString('abc');
	   * // => true
	   *
	   * _.isString(1);
	   * // => false
	   */
	  function isString(value) {
	    return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	  }

	  return isString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** Used for native method references. */
	  var arrayProto = Array.prototype,
	      errorProto = Error.prototype,
	      objectProto = Object.prototype;

	  /** Native method references. */
	  var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	      splice = arrayProto.splice;

	  /**
	   * An object environment feature flags.
	   *
	   * @static
	   * @memberOf _
	   * @type Object
	   */
	  var support = {};

	  (function(x) {
	    var Ctor = function() { this.x = x; },
	        object = { '0': x, 'length': x },
	        props = [];

	    Ctor.prototype = { 'valueOf': x, 'y': x };
	    for (var key in new Ctor) { props.push(key); }

	    /**
	     * Detect if `name` or `message` properties of `Error.prototype` are
	     * enumerable by default (IE < 9, Safari < 5.1).
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	      propertyIsEnumerable.call(errorProto, 'name');

	    /**
	     * Detect if `prototype` properties are enumerable by default.
	     *
	     * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	     * (if the prototype or a property on the prototype has been set)
	     * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	     * property to `true`.
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');

	    /**
	     * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	     *
	     * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	     * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.nonEnumShadows = !/valueOf/.test(props);

	    /**
	     * Detect if own properties are iterated after inherited properties (IE < 9).
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.ownLast = props[0] != 'x';

	    /**
	     * Detect if `Array#shift` and `Array#splice` augment array-like objects
	     * correctly.
	     *
	     * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	     * `shift()` and `splice()` functions that fail to remove the last element,
	     * `value[0]`, of array-like objects even though the "length" property is
	     * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	     * while `splice()` is buggy regardless of mode in IE < 9.
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.spliceObjects = (splice.call(object, 0, 1), !object[0]);

	    /**
	     * Detect lack of support for accessing string characters by index.
	     *
	     * IE < 8 can't access characters by index. IE 8 can only access characters
	     * by index on string literals, not string objects.
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	  }(1, 0));

	  return support;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	   * of an array-like value.
	   */
	  var MAX_SAFE_INTEGER = 9007199254740991;

	  /**
	   * Checks if `value` is a valid array-like length.
	   *
	   * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	   */
	  function isLength(value) {
	    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	  }

	  return isLength;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(47), __webpack_require__(48), __webpack_require__(44), __webpack_require__(42), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArguments, isArray, isIndex, isLength, isString, keysIn) {

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /**
	   * A fallback implementation of `Object.keys` which creates an array of the
	   * own enumerable property names of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the array of property names.
	   */
	  function shimKeys(object) {
	    var props = keysIn(object),
	        propsLength = props.length,
	        length = propsLength && object.length;

	    var allowIndexes = !!length && isLength(length) &&
	      (isArray(object) || isArguments(object) || isString(object));

	    var index = -1,
	        result = [];

	    while (++index < propsLength) {
	      var key = props[index];
	      if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	        result.push(key);
	      }
	    }
	    return result;
	  }

	  return shimKeys;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(38), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArrayLike, isObjectLike) {

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /** Native method references. */
	  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	  /**
	   * Checks if `value` is classified as an `arguments` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isArguments(function() { return arguments; }());
	   * // => true
	   *
	   * _.isArguments([1, 2, 3]);
	   * // => false
	   */
	  function isArguments(value) {
	    return isObjectLike(value) && isArrayLike(value) &&
	      hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	  }

	  return isArguments;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32), __webpack_require__(44), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(getNative, isLength, isObjectLike) {

	  /** `Object#toString` result references. */
	  var arrayTag = '[object Array]';

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /* Native method references for those with the same name as other `lodash` methods. */
	  var nativeIsArray = getNative(Array, 'isArray');

	  /**
	   * Checks if `value` is classified as an `Array` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   *
	   * _.isArray(function() { return arguments; }());
	   * // => false
	   */
	  var isArray = nativeIsArray || function(value) {
	    return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	  };

	  return isArray;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;

	  /**
	   * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	   * of an array-like value.
	   */
	  var MAX_SAFE_INTEGER = 9007199254740991;

	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return value > -1 && value % 1 == 0 && value < length;
	  }

	  return isIndex;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(50), __webpack_require__(46), __webpack_require__(47), __webpack_require__(34), __webpack_require__(48), __webpack_require__(44), __webpack_require__(35), __webpack_require__(42), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayEach, isArguments, isArray, isFunction, isIndex, isLength, isObject, isString, support) {

	  /** `Object#toString` result references. */
	  var arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      stringTag = '[object String]';

	  /** Used to fix the JScript `[[DontEnum]]` bug. */
	  var shadowProps = [
	    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	    'toLocaleString', 'toString', 'valueOf'
	  ];

	  /** Used for native method references. */
	  var errorProto = Error.prototype,
	      objectProto = Object.prototype,
	      stringProto = String.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /** Used to avoid iterating over non-enumerable properties in IE < 9. */
	  var nonEnumProps = {};
	  nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	  nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	  nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	  nonEnumProps[objectTag] = { 'constructor': true };

	  arrayEach(shadowProps, function(key) {
	    for (var tag in nonEnumProps) {
	      if (hasOwnProperty.call(nonEnumProps, tag)) {
	        var props = nonEnumProps[tag];
	        props[key] = hasOwnProperty.call(props, key);
	      }
	    }
	  });

	  /**
	   * Creates an array of the own and inherited enumerable property names of `object`.
	   *
	   * **Note:** Non-object values are coerced to objects.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the array of property names.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.keysIn(new Foo);
	   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	   */
	  function keysIn(object) {
	    if (object == null) {
	      return [];
	    }
	    if (!isObject(object)) {
	      object = Object(object);
	    }
	    var length = object.length;

	    length = (length && isLength(length) &&
	      (isArray(object) || isArguments(object) || isString(object)) && length) || 0;

	    var Ctor = object.constructor,
	        index = -1,
	        proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	        isProto = proto === object,
	        result = Array(length),
	        skipIndexes = length > 0,
	        skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	        skipProto = support.enumPrototypes && isFunction(object);

	    while (++index < length) {
	      result[index] = (index + '');
	    }
	    // lodash skips the `constructor` property when it infers it's iterating
	    // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	    // attribute of an existing property and the `constructor` property of a
	    // prototype defaults to non-enumerable.
	    for (var key in object) {
	      if (!(skipProto && key == 'prototype') &&
	          !(skipErrorProps && (key == 'message' || key == 'name')) &&
	          !(skipIndexes && isIndex(key, length)) &&
	          !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	        result.push(key);
	      }
	    }
	    if (support.nonEnumShadows && object !== objectProto) {
	      var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	          nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];

	      if (tag == objectTag) {
	        proto = objectProto;
	      }
	      length = shadowProps.length;
	      while (length--) {
	        key = shadowProps[length];
	        var nonEnum = nonEnums[key];
	        if (!(isProto && nonEnum) &&
	            (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	          result.push(key);
	        }
	      }
	    }
	    return result;
	  }

	  return keysIn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * A specialized version of `_.forEach` for arrays without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  return arrayEach;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize include="merge,map"`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(52), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseMerge, createAssigner) {

	  /**
	   * Recursively merges own enumerable properties of the source object(s), that
	   * don't resolve to `undefined` into the destination object. Subsequent sources
	   * overwrite property assignments of previous sources. If `customizer` is
	   * provided it's invoked to produce the merged values of the destination and
	   * source properties. If `customizer` returns `undefined` merging is handled
	   * by the method instead. The `customizer` is bound to `thisArg` and invoked
	   * with five arguments: (objectValue, sourceValue, key, object, source).
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The destination object.
	   * @param {...Object} [sources] The source objects.
	   * @param {Function} [customizer] The function to customize assigned values.
	   * @param {*} [thisArg] The `this` binding of `customizer`.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * var users = {
	   *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	   * };
	   *
	   * var ages = {
	   *   'data': [{ 'age': 36 }, { 'age': 40 }]
	   * };
	   *
	   * _.merge(users, ages);
	   * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	   *
	   * // using a customizer callback
	   * var object = {
	   *   'fruits': ['apple'],
	   *   'vegetables': ['beet']
	   * };
	   *
	   * var other = {
	   *   'fruits': ['banana'],
	   *   'vegetables': ['carrot']
	   * };
	   *
	   * _.merge(object, other, function(a, b) {
	   *   if (_.isArray(a)) {
	   *     return a.concat(b);
	   *   }
	   * });
	   * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	   */
	  var merge = createAssigner(baseMerge);

	  return merge;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(50), __webpack_require__(53), __webpack_require__(47), __webpack_require__(38), __webpack_require__(35), __webpack_require__(37), __webpack_require__(59), __webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayEach, baseMergeDeep, isArray, isArrayLike, isObject, isObjectLike, isTypedArray, keys) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.merge` without support for argument juggling,
	   * multiple sources, and `this` binding `customizer` functions.
	   *
	   * @private
	   * @param {Object} object The destination object.
	   * @param {Object} source The source object.
	   * @param {Function} [customizer] The function to customize merged values.
	   * @param {Array} [stackA=[]] Tracks traversed source objects.
	   * @param {Array} [stackB=[]] Associates values with source counterparts.
	   * @returns {Object} Returns `object`.
	   */
	  function baseMerge(object, source, customizer, stackA, stackB) {
	    if (!isObject(object)) {
	      return object;
	    }
	    var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	        props = isSrcArr ? undefined : keys(source);

	    arrayEach(props || source, function(srcValue, key) {
	      if (props) {
	        key = srcValue;
	        srcValue = source[key];
	      }
	      if (isObjectLike(srcValue)) {
	        stackA || (stackA = []);
	        stackB || (stackB = []);
	        baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	      }
	      else {
	        var value = object[key],
	            result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	            isCommon = result === undefined;

	        if (isCommon) {
	          result = srcValue;
	        }

	        if ((result !== undefined || (isSrcArr && !(key in object))) &&
	            (isCommon || (result === result ? (result !== value) : (value === value)))) {
	          object[key] = result;
	        }
	      }
	    });
	    return object;
	  }

	  return baseMerge;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(54), __webpack_require__(46), __webpack_require__(47), __webpack_require__(38), __webpack_require__(55), __webpack_require__(59), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayCopy, isArguments, isArray, isArrayLike, isPlainObject, isTypedArray, toPlainObject) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * A specialized version of `baseMerge` for arrays and objects which performs
	   * deep merges and tracks traversed objects enabling objects with circular
	   * references to be merged.
	   *
	   * @private
	   * @param {Object} object The destination object.
	   * @param {Object} source The source object.
	   * @param {string} key The key of the value to merge.
	   * @param {Function} mergeFunc The function to merge values.
	   * @param {Function} [customizer] The function to customize merged values.
	   * @param {Array} [stackA=[]] Tracks traversed source objects.
	   * @param {Array} [stackB=[]] Associates values with source counterparts.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	    var length = stackA.length,
	        srcValue = source[key];

	    while (length--) {
	      if (stackA[length] == srcValue) {
	        object[key] = stackB[length];
	        return;
	      }
	    }
	    var value = object[key],
	        result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	        isCommon = result === undefined;

	    if (isCommon) {
	      result = srcValue;
	      if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	        result = isArray(value)
	          ? value
	          : (isArrayLike(value) ? arrayCopy(value) : []);
	      }
	      else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	        result = isArguments(value)
	          ? toPlainObject(value)
	          : (isPlainObject(value) ? value : {});
	      }
	      else {
	        isCommon = false;
	      }
	    }
	    // Add the source value to the stack of traversed objects and associate
	    // it with its merged value.
	    stackA.push(srcValue);
	    stackB.push(result);

	    if (isCommon) {
	      // Recursively merge objects and arrays (susceptible to call stack limits).
	      object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	    } else if (result === result ? (result !== value) : (value === value)) {
	      object[key] = result;
	    }
	  }

	  return baseMergeDeep;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Copies the values of `source` to `array`.
	   *
	   * @private
	   * @param {Array} source The array to copy values from.
	   * @param {Array} [array=[]] The array to copy values to.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayCopy(source, array) {
	    var index = -1,
	        length = source.length;

	    array || (array = Array(length));
	    while (++index < length) {
	      array[index] = source[index];
	    }
	    return array;
	  }

	  return arrayCopy;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(46), __webpack_require__(36), __webpack_require__(37), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseForIn, isArguments, isHostObject, isObjectLike, support) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** `Object#toString` result references. */
	  var objectTag = '[object Object]';

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /**
	   * Checks if `value` is a plain object, that is, an object created by the
	   * `Object` constructor or one with a `[[Prototype]]` of `null`.
	   *
	   * **Note:** This method assumes objects created by the `Object` constructor
	   * have no inherited enumerable properties.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   * }
	   *
	   * _.isPlainObject(new Foo);
	   * // => false
	   *
	   * _.isPlainObject([1, 2, 3]);
	   * // => false
	   *
	   * _.isPlainObject({ 'x': 0, 'y': 0 });
	   * // => true
	   *
	   * _.isPlainObject(Object.create(null));
	   * // => true
	   */
	  function isPlainObject(value) {
	    var Ctor;

	    // Exit early for non `Object` objects.
	    if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isHostObject(value) && !isArguments(value)) ||
	        (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	      return false;
	    }
	    // IE < 9 iterates inherited properties before own properties. If the first
	    // iterated property is an object's own property then there are no inherited
	    // enumerable properties.
	    var result;
	    if (support.ownLast) {
	      baseForIn(value, function(subValue, key, object) {
	        result = hasOwnProperty.call(object, key);
	        return false;
	      });
	      return result !== false;
	    }
	    // In most environments an object's own properties are iterated before
	    // its inherited properties. If the last iterated property is an object's
	    // own property then there are no inherited enumerable properties.
	    baseForIn(value, function(subValue, key) {
	      result = key;
	    });
	    return result === undefined || hasOwnProperty.call(value, result);
	  }

	  return isPlainObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(57), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseFor, keysIn) {

	  /**
	   * The base implementation of `_.forIn` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Object} Returns `object`.
	   */
	  function baseForIn(object, iteratee) {
	    return baseFor(object, iteratee, keysIn);
	  }

	  return baseForIn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58)], __WEBPACK_AMD_DEFINE_RESULT__ = function(createBaseFor) {

	  /**
	   * The base implementation of `baseForIn` and `baseForOwn` which iterates
	   * over `object` properties returned by `keysFunc` invoking `iteratee` for
	   * each property. Iteratee functions may exit iteration early by explicitly
	   * returning `false`.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {Function} keysFunc The function to get the keys of `object`.
	   * @returns {Object} Returns `object`.
	   */
	  var baseFor = createBaseFor();

	  return baseFor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(toObject) {

	  /**
	   * Creates a base function for `_.forIn` or `_.forInRight`.
	   *
	   * @private
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {Function} Returns the new base function.
	   */
	  function createBaseFor(fromRight) {
	    return function(object, iteratee, keysFunc) {
	      var iterable = toObject(object),
	          props = keysFunc(object),
	          length = props.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length)) {
	        var key = props[index];
	        if (iteratee(iterable[key], key, iterable) === false) {
	          break;
	        }
	      }
	      return object;
	    };
	  }

	  return createBaseFor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(44), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isLength, isObjectLike) {

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /**
	   * Checks if `value` is classified as a typed array.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isTypedArray(new Uint8Array);
	   * // => true
	   *
	   * _.isTypedArray([]);
	   * // => false
	   */
	  function isTypedArray(value) {
	    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	  }

	  return isTypedArray;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(61), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseCopy, keysIn) {

	  /**
	   * Converts `value` to a plain object flattening inherited enumerable
	   * properties of `value` to own properties of the plain object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to convert.
	   * @returns {Object} Returns the converted plain object.
	   * @example
	   *
	   * function Foo() {
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.assign({ 'a': 1 }, new Foo);
	   * // => { 'a': 1, 'b': 2 }
	   *
	   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	   * // => { 'a': 1, 'b': 2, 'c': 3 }
	   */
	  function toPlainObject(value) {
	    return baseCopy(value, keysIn(value));
	  }

	  return toPlainObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Copies properties of `source` to `object`.
	   *
	   * @private
	   * @param {Object} source The object to copy properties from.
	   * @param {Array} props The property names to copy.
	   * @param {Object} [object={}] The object to copy properties to.
	   * @returns {Object} Returns `object`.
	   */
	  function baseCopy(source, props, object) {
	    object || (object = {});

	    var index = -1,
	        length = props.length;

	    while (++index < length) {
	      var key = props[index];
	      object[key] = source[key];
	    }
	    return object;
	  }

	  return baseCopy;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(63), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function(bindCallback, isIterateeCall, restParam) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	   *
	   * @private
	   * @param {Function} assigner The function to assign values.
	   * @returns {Function} Returns the new assigner function.
	   */
	  function createAssigner(assigner) {
	    return restParam(function(object, sources) {
	      var index = -1,
	          length = object == null ? 0 : sources.length,
	          customizer = length > 2 ? sources[length - 2] : undefined,
	          guard = length > 2 ? sources[2] : undefined,
	          thisArg = length > 1 ? sources[length - 1] : undefined;

	      if (typeof customizer == 'function') {
	        customizer = bindCallback(customizer, thisArg, 5);
	        length -= 2;
	      } else {
	        customizer = typeof thisArg == 'function' ? thisArg : undefined;
	        length -= (customizer ? 1 : 0);
	      }
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        customizer = length < 3 ? undefined : customizer;
	        length = 1;
	      }
	      while (++index < length) {
	        var source = sources[index];
	        if (source) {
	          assigner(object, source, customizer);
	        }
	      }
	      return object;
	    });
	  }

	  return createAssigner;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(64)], __WEBPACK_AMD_DEFINE_RESULT__ = function(identity) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * A specialized version of `baseCallback` which only supports `this` binding
	   * and specifying the number of arguments to provide to `func`.
	   *
	   * @private
	   * @param {Function} func The function to bind.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {number} [argCount] The number of arguments to provide to `func`.
	   * @returns {Function} Returns the callback.
	   */
	  function bindCallback(func, thisArg, argCount) {
	    if (typeof func != 'function') {
	      return identity;
	    }
	    if (thisArg === undefined) {
	      return func;
	    }
	    switch (argCount) {
	      case 1: return function(value) {
	        return func.call(thisArg, value);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(thisArg, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(thisArg, accumulator, value, index, collection);
	      };
	      case 5: return function(value, other, key, object, source) {
	        return func.call(thisArg, value, other, key, object, source);
	      };
	    }
	    return function() {
	      return func.apply(thisArg, arguments);
	    };
	  }

	  return bindCallback;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * This method returns the first argument provided to it.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {*} value Any value.
	   * @returns {*} Returns `value`.
	   * @example
	   *
	   * var object = { 'user': 'fred' };
	   *
	   * _.identity(object) === object;
	   * // => true
	   */
	  function identity(value) {
	    return value;
	  }

	  return identity;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(38), __webpack_require__(48), __webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArrayLike, isIndex, isObject) {

	  /**
	   * Checks if the provided arguments are from an iteratee call.
	   *
	   * @private
	   * @param {*} value The potential iteratee value argument.
	   * @param {*} index The potential iteratee index or key argument.
	   * @param {*} object The potential iteratee object argument.
	   * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	   */
	  function isIterateeCall(value, index, object) {
	    if (!isObject(object)) {
	      return false;
	    }
	    var type = typeof index;
	    if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)) {
	      var other = object[index];
	      return value === value ? (value === other) : (other !== other);
	    }
	    return false;
	  }

	  return isIterateeCall;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';

	  /* Native method references for those with the same name as other `lodash` methods. */
	  var nativeMax = Math.max;

	  /**
	   * Creates a function that invokes `func` with the `this` binding of the
	   * created function and arguments from `start` and beyond provided as an array.
	   *
	   * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	   *
	   * @static
	   * @memberOf _
	   * @category Function
	   * @param {Function} func The function to apply a rest parameter to.
	   * @param {number} [start=func.length-1] The start position of the rest parameter.
	   * @returns {Function} Returns the new function.
	   * @example
	   *
	   * var say = _.restParam(function(what, names) {
	   *   return what + ' ' + _.initial(names).join(', ') +
	   *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	   * });
	   *
	   * say('hello', 'fred', 'barney', 'pebbles');
	   * // => 'hello fred, barney, & pebbles'
	   */
	  function restParam(func, start) {
	    if (typeof func != 'function') {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	    return function() {
	      var args = arguments,
	          index = -1,
	          length = nativeMax(args.length - start, 0),
	          rest = Array(length);

	      while (++index < length) {
	        rest[index] = args[start + index];
	      }
	      switch (start) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, args[0], rest);
	        case 2: return func.call(this, args[0], args[1], rest);
	      }
	      var otherArgs = Array(start + 1);
	      index = -1;
	      while (++index < start) {
	        otherArgs[index] = args[index];
	      }
	      otherArgs[start] = rest;
	      return func.apply(this, otherArgs);
	    };
	  }

	  return restParam;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys, toObject) {

	  /**
	   * Creates a two dimensional array of the key-value pairs for `object`,
	   * e.g. `[[key1, value1], [key2, value2]]`.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the new array of key-value pairs.
	   * @example
	   *
	   * _.pairs({ 'barney': 36, 'fred': 40 });
	   * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	   */
	  function pairs(object) {
	    object = toObject(object);

	    var index = -1,
	        props = keys(object),
	        length = props.length,
	        result = Array(length);

	    while (++index < length) {
	      var key = props[index];
	      result[index] = [key, object[key]];
	    }
	    return result;
	  }

	  return pairs;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(69)], __WEBPACK_AMD_DEFINE_RESULT__ = function(map) {
	    'use strict';

	    var firstUpperCase = function firstUpperCase(str) {
	        if (!str) {
	            return str;
	        }

	        return str[0].toUpperCase() + str.slice(1);
	    };

	    var firstLowerCase = function firstLowerCase(str) {
	        if (!str) {
	            return str;
	        }

	        return str[0].toLowerCase() + str.slice(1);
	    };

	    var separators = ['_', '-', '.', '/'];
	    /**
	     * Converts a string of (possibly mixed) formats: camelCase, PascalCase, snake_case, dash-case, dot.case, slash/case to a string with the given separator.
	     * @param str
	     * @param separator
	     * @returns {str}
	     */
	    var separatorCase = function(str, separator, toUpper) {
	        if (!str) {
	            return str;
	        }

	        if (separators.indexOf(separator) < 0) {
	            throw new Error('Tried to call separatorCase with an unknown separator: ' + separator);
	        }

	        var replaceSeparators = separators.slice();
	        replaceSeparators.splice(separators.indexOf(separator), 1);
	        replaceSeparators = map(replaceSeparators, function(separator) {
	            return separator === '-' ? '\\-' : separator;
	        });

	        str = firstLowerCase(str);
	        var regex = new RegExp(['['].concat(replaceSeparators).concat([']']).join(''), 'g');
	        str = str.replace(regex, separator);

	        str = str.replace(/[A-Z]/g, function($1) {
	            return separator + $1.toLowerCase();
	        });

	        return toUpper ? str.toUpperCase() : str;
	    };

	    var snakeCase = function snakeCase(str) {
	        return separatorCase(str, '_');
	    };

	    var dashCase = function dashCase(str) {
	        return separatorCase(str, '-');
	    };

	    var slashCase = function slashCase(str) {
	        return separatorCase(str, '/');
	    };

	    var dotCase = function dotCase(str) {
	        return separatorCase(str, '.');
	    };

	    var camelCase = function camelCase(str) {
	        if (str === str.toUpperCase()) {
	            str = str.toLowerCase();
	        }

	        return str.replace(/(?:^\w|[A-Z]|(?:\b|_)\w)/g, function(letter, index) {
	            return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
	        }).replace(/[\s\-._]+/g, '');
	    };

	    var format = function format(str) {
	        if (str === null) {
	            return null;
	        }
	        var args = Array.prototype.slice.call(arguments, 1);
	        return str.replace(/{{(\d+)}}/g, function(match, number) {
	            return typeof args[number] != 'undefined'
	              ? args[number]
	              : match
	            ;
	        });
	    }

	    return {
	        firstUpperCase: firstUpperCase,
	        firstLowerCase: firstLowerCase,
	        dashCase: dashCase,
	        snakeCase: snakeCase,
	        slashCase: slashCase,
	        dotCase: dotCase,
	        separatorCase: separatorCase,
	        camelCase: camelCase,
	        format: format
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArray) {
	    'use strict';
	    var _ = __webpack_require__(70);
	    return _.map;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(71), __webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function(collect, map) {
	  return {
	    'collect': collect,
	    'map': map
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(72)], __WEBPACK_AMD_DEFINE_RESULT__ = function(map) {
	  return map;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize include="merge,map"`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(73), __webpack_require__(74), __webpack_require__(94), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arrayMap, baseCallback, baseMap, isArray) {

	  /**
	   * Creates an array of values by running each element in `collection` through
	   * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	   * arguments: (value, index|key, collection).
	   *
	   * If a property name is provided for `iteratee` the created `_.property`
	   * style callback returns the property value of the given element.
	   *
	   * If a value is also provided for `thisArg` the created `_.matchesProperty`
	   * style callback returns `true` for elements that have a matching property
	   * value, else `false`.
	   *
	   * If an object is provided for `iteratee` the created `_.matches` style
	   * callback returns `true` for elements that have the properties of the given
	   * object, else `false`.
	   *
	   * Many lodash methods are guarded to work as iteratees for methods like
	   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	   *
	   * The guarded methods are:
	   * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	   * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	   * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	   * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	   * `sum`, `uniq`, and `words`
	   *
	   * @static
	   * @memberOf _
	   * @alias collect
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	   *  per iteration.
	   * @param {*} [thisArg] The `this` binding of `iteratee`.
	   * @returns {Array} Returns the new mapped array.
	   * @example
	   *
	   * function timesThree(n) {
	   *   return n * 3;
	   * }
	   *
	   * _.map([1, 2], timesThree);
	   * // => [3, 6]
	   *
	   * _.map({ 'a': 1, 'b': 2 }, timesThree);
	   * // => [3, 6] (iteration order is not guaranteed)
	   *
	   * var users = [
	   *   { 'user': 'barney' },
	   *   { 'user': 'fred' }
	   * ];
	   *
	   * // using the `_.property` callback shorthand
	   * _.map(users, 'user');
	   * // => ['barney', 'fred']
	   */
	  function map(collection, iteratee, thisArg) {
	    var func = isArray(collection) ? arrayMap : baseMap;
	    iteratee = baseCallback(iteratee, thisArg, 3);
	    return func(collection, iteratee);
	  }

	  return map;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * A specialized version of `_.map` for arrays without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  return arrayMap;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(75), __webpack_require__(85), __webpack_require__(63), __webpack_require__(64), __webpack_require__(92)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseMatches, baseMatchesProperty, bindCallback, identity, property) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.callback` which supports specifying the
	   * number of arguments to provide to `func`.
	   *
	   * @private
	   * @param {*} [func=_.identity] The value to convert to a callback.
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @param {number} [argCount] The number of arguments to provide to `func`.
	   * @returns {Function} Returns the callback.
	   */
	  function baseCallback(func, thisArg, argCount) {
	    var type = typeof func;
	    if (type == 'function') {
	      return thisArg === undefined
	        ? func
	        : bindCallback(func, thisArg, argCount);
	    }
	    if (func == null) {
	      return identity;
	    }
	    if (type == 'object') {
	      return baseMatches(func);
	    }
	    return thisArg === undefined
	      ? property(func)
	      : baseMatchesProperty(func, thisArg);
	  }

	  return baseCallback;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(76), __webpack_require__(83), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIsMatch, getMatchData, toObject) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.matches` which does not clone `source`.
	   *
	   * @private
	   * @param {Object} source The object of property values to match.
	   * @returns {Function} Returns the new function.
	   */
	  function baseMatches(source) {
	    var matchData = getMatchData(source);
	    if (matchData.length == 1 && matchData[0][2]) {
	      var key = matchData[0][0],
	          value = matchData[0][1];

	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        object = toObject(object);
	        return object[key] === value && (value !== undefined || (key in object));
	      };
	    }
	    return function(object) {
	      return baseIsMatch(object, matchData);
	    };
	  }

	  return baseMatches;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(77), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIsEqual, toObject) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.isMatch` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to inspect.
	   * @param {Array} matchData The propery names, values, and compare flags to match.
	   * @param {Function} [customizer] The function to customize comparing objects.
	   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	   */
	  function baseIsMatch(object, matchData, customizer) {
	    var index = matchData.length,
	        length = index,
	        noCustomizer = !customizer;

	    if (object == null) {
	      return !length;
	    }
	    object = toObject(object);
	    while (index--) {
	      var data = matchData[index];
	      if ((noCustomizer && data[2])
	            ? data[1] !== object[data[0]]
	            : !(data[0] in object)
	          ) {
	        return false;
	      }
	    }
	    while (++index < length) {
	      data = matchData[index];
	      var key = data[0],
	          objValue = object[key],
	          srcValue = data[1];

	      if (noCustomizer && data[2]) {
	        if (objValue === undefined && !(key in object)) {
	          return false;
	        }
	      } else {
	        var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	        if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  }

	  return baseIsMatch;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(78), __webpack_require__(35), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseIsEqualDeep, isObject, isObjectLike) {

	  /**
	   * The base implementation of `_.isEqual` without support for `this` binding
	   * `customizer` functions.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @param {Function} [customizer] The function to customize comparing values.
	   * @param {boolean} [isLoose] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   */
	  function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	    if (value === other) {
	      return true;
	    }
	    if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	      return value !== value && other !== other;
	    }
	    return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	  }

	  return baseIsEqual;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(79), __webpack_require__(81), __webpack_require__(82), __webpack_require__(47), __webpack_require__(36), __webpack_require__(59)], __WEBPACK_AMD_DEFINE_RESULT__ = function(equalArrays, equalByTag, equalObjects, isArray, isHostObject, isTypedArray) {

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      objectTag = '[object Object]';

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objToString = objectProto.toString;

	  /**
	   * A specialized version of `baseIsEqual` for arrays and objects which performs
	   * deep comparisons and tracks traversed objects enabling objects with circular
	   * references to be compared.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing objects.
	   * @param {boolean} [isLoose] Specify performing partial comparisons.
	   * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	   * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	    var objIsArr = isArray(object),
	        othIsArr = isArray(other),
	        objTag = arrayTag,
	        othTag = arrayTag;

	    if (!objIsArr) {
	      objTag = objToString.call(object);
	      if (objTag == argsTag) {
	        objTag = objectTag;
	      } else if (objTag != objectTag) {
	        objIsArr = isTypedArray(object);
	      }
	    }
	    if (!othIsArr) {
	      othTag = objToString.call(other);
	      if (othTag == argsTag) {
	        othTag = objectTag;
	      } else if (othTag != objectTag) {
	        othIsArr = isTypedArray(other);
	      }
	    }
	    var objIsObj = objTag == objectTag && !isHostObject(object),
	        othIsObj = othTag == objectTag && !isHostObject(other),
	        isSameTag = objTag == othTag;

	    if (isSameTag && !(objIsArr || objIsObj)) {
	      return equalByTag(object, other, objTag);
	    }
	    if (!isLoose) {
	      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	      if (objIsWrapped || othIsWrapped) {
	        return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	      }
	    }
	    if (!isSameTag) {
	      return false;
	    }
	    // Assume cyclic values are equal.
	    // For more information on detecting circular references see https://es5.github.io/#JO.
	    stackA || (stackA = []);
	    stackB || (stackB = []);

	    var length = stackA.length;
	    while (length--) {
	      if (stackA[length] == object) {
	        return stackB[length] == other;
	      }
	    }
	    // Add `object` and `other` to the stack of traversed objects.
	    stackA.push(object);
	    stackB.push(other);

	    var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

	    stackA.pop();
	    stackB.pop();

	    return result;
	  }

	  return baseIsEqualDeep;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(80)], __WEBPACK_AMD_DEFINE_RESULT__ = function(arraySome) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * A specialized version of `baseIsEqualDeep` for arrays with support for
	   * partial deep comparisons.
	   *
	   * @private
	   * @param {Array} array The array to compare.
	   * @param {Array} other The other array to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing arrays.
	   * @param {boolean} [isLoose] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	   */
	  function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	    var index = -1,
	        arrLength = array.length,
	        othLength = other.length;

	    if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	      return false;
	    }
	    // Ignore non-index properties.
	    while (++index < arrLength) {
	      var arrValue = array[index],
	          othValue = other[index],
	          result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

	      if (result !== undefined) {
	        if (result) {
	          continue;
	        }
	        return false;
	      }
	      // Recursively compare arrays (susceptible to call stack limits).
	      if (isLoose) {
	        if (!arraySome(other, function(othValue) {
	              return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	            })) {
	          return false;
	        }
	      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	        return false;
	      }
	    }
	    return true;
	  }

	  return equalArrays;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * A specialized version of `_.some` for arrays without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  return arraySome;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** `Object#toString` result references. */
	  var boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      numberTag = '[object Number]',
	      regexpTag = '[object RegExp]',
	      stringTag = '[object String]';

	  /**
	   * A specialized version of `baseIsEqualDeep` for comparing objects of
	   * the same `toStringTag`.
	   *
	   * **Note:** This function only supports comparing values with tags of
	   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {string} tag The `toStringTag` of the objects to compare.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function equalByTag(object, other, tag) {
	    switch (tag) {
	      case boolTag:
	      case dateTag:
	        // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	        // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	        return +object == +other;

	      case errorTag:
	        return object.name == other.name && object.message == other.message;

	      case numberTag:
	        // Treat `NaN` vs. `NaN` as equal.
	        return (object != +object)
	          ? other != +other
	          : object == +other;

	      case regexpTag:
	      case stringTag:
	        // Coerce regexes to strings and treat strings primitives and string
	        // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	        return object == (other + '');
	    }
	    return false;
	  }

	  return equalByTag;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(keys) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /**
	   * A specialized version of `baseIsEqualDeep` for objects with support for
	   * partial deep comparisons.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing values.
	   * @param {boolean} [isLoose] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	    var objProps = keys(object),
	        objLength = objProps.length,
	        othProps = keys(other),
	        othLength = othProps.length;

	    if (objLength != othLength && !isLoose) {
	      return false;
	    }
	    var index = objLength;
	    while (index--) {
	      var key = objProps[index];
	      if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	        return false;
	      }
	    }
	    var skipCtor = isLoose;
	    while (++index < objLength) {
	      key = objProps[index];
	      var objValue = object[key],
	          othValue = other[key],
	          result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

	      // Recursively compare objects (susceptible to call stack limits).
	      if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	        return false;
	      }
	      skipCtor || (skipCtor = key == 'constructor');
	    }
	    if (!skipCtor) {
	      var objCtor = object.constructor,
	          othCtor = other.constructor;

	      // Non `Object` object instances with different constructors are not equal.
	      if (objCtor != othCtor &&
	          ('constructor' in object && 'constructor' in other) &&
	          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  return equalObjects;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(84), __webpack_require__(67)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isStrictComparable, pairs) {

	  /**
	   * Gets the propery names, values, and compare flags of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the match data of `object`.
	   */
	  function getMatchData(object) {
	    var result = pairs(object),
	        length = result.length;

	    while (length--) {
	      result[length][2] = isStrictComparable(result[length][1]);
	    }
	    return result;
	  }

	  return getMatchData;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isObject) {

	  /**
	   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` if suitable for strict
	   *  equality comparisons, else `false`.
	   */
	  function isStrictComparable(value) {
	    return value === value && !isObject(value);
	  }

	  return isStrictComparable;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(86), __webpack_require__(77), __webpack_require__(87), __webpack_require__(47), __webpack_require__(88), __webpack_require__(84), __webpack_require__(89), __webpack_require__(41), __webpack_require__(90)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseGet, baseIsEqual, baseSlice, isArray, isKey, isStrictComparable, last, toObject, toPath) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	   *
	   * @private
	   * @param {string} path The path of the property to get.
	   * @param {*} srcValue The value to compare.
	   * @returns {Function} Returns the new function.
	   */
	  function baseMatchesProperty(path, srcValue) {
	    var isArr = isArray(path),
	        isCommon = isKey(path) && isStrictComparable(srcValue),
	        pathKey = (path + '');

	    path = toPath(path);
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      var key = pathKey;
	      object = toObject(object);
	      if ((isArr || !isCommon) && !(key in object)) {
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        key = last(path);
	        object = toObject(object);
	      }
	      return object[key] === srcValue
	        ? (srcValue !== undefined || (key in object))
	        : baseIsEqual(srcValue, object[key], undefined, true);
	    };
	  }

	  return baseMatchesProperty;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(toObject) {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `get` without support for string paths
	   * and default values.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} path The path of the property to get.
	   * @param {string} [pathKey] The key representation of path.
	   * @returns {*} Returns the resolved value.
	   */
	  function baseGet(object, path, pathKey) {
	    if (object == null) {
	      return;
	    }
	    object = toObject(object);
	    if (pathKey !== undefined && pathKey in object) {
	      path = [pathKey];
	    }
	    var index = 0,
	        length = path.length;

	    while (object != null && index < length) {
	      object = toObject(object)[path[index++]];
	    }
	    return (index && index == length) ? object : undefined;
	  }

	  return baseGet;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * The base implementation of `_.slice` without an iteratee call guard.
	   *
	   * @private
	   * @param {Array} array The array to slice.
	   * @param {number} [start=0] The start position.
	   * @param {number} [end=array.length] The end position.
	   * @returns {Array} Returns the slice of `array`.
	   */
	  function baseSlice(array, start, end) {
	    var index = -1,
	        length = array.length;

	    start = start == null ? 0 : (+start || 0);
	    if (start < 0) {
	      start = -start > length ? 0 : (length + start);
	    }
	    end = (end === undefined || end > length) ? length : (+end || 0);
	    if (end < 0) {
	      end += length;
	    }
	    length = start > end ? 0 : ((end - start) >>> 0);
	    start >>>= 0;

	    var result = Array(length);
	    while (++index < length) {
	      result[index] = array[index + start];
	    }
	    return result;
	  }

	  return baseSlice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(isArray, toObject) {

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/;

	  /**
	   * Checks if `value` is a property name and not a property path.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {Object} [object] The object to query keys on.
	   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	   */
	  function isKey(value, object) {
	    var type = typeof value;
	    if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	      return true;
	    }
	    if (isArray(value)) {
	      return false;
	    }
	    var result = !reIsDeepProp.test(value);
	    return result || (object != null && value in toObject(object));
	  }

	  return isKey;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /**
	   * Gets the last element of `array`.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {Array} array The array to query.
	   * @returns {*} Returns the last element of `array`.
	   * @example
	   *
	   * _.last([1, 2, 3]);
	   * // => 3
	   */
	  function last(array) {
	    var length = array ? array.length : 0;
	    return length ? array[length - 1] : undefined;
	  }

	  return last;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(91), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseToString, isArray) {

	  /** Used to match property names within property paths. */
	  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Converts `value` to property path array if it's not one.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {Array} Returns the property path array.
	   */
	  function toPath(value) {
	    if (isArray(value)) {
	      return value;
	    }
	    var result = [];
	    baseToString(value).replace(rePropName, function(match, number, quote, string) {
	      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	    });
	    return result;
	  }

	  return toPath;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {

	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }

	  return baseToString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(40), __webpack_require__(93), __webpack_require__(88)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseProperty, basePropertyDeep, isKey) {

	  /**
	   * Creates a function that returns the property value at `path` on a
	   * given object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Array|string} path The path of the property to get.
	   * @returns {Function} Returns the new function.
	   * @example
	   *
	   * var objects = [
	   *   { 'a': { 'b': { 'c': 2 } } },
	   *   { 'a': { 'b': { 'c': 1 } } }
	   * ];
	   *
	   * _.map(objects, _.property('a.b.c'));
	   * // => [2, 1]
	   *
	   * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	   * // => [1, 2]
	   */
	  function property(path) {
	    return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	  }

	  return property;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(86), __webpack_require__(90)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseGet, toPath) {

	  /**
	   * A specialized version of `baseProperty` which supports deep paths.
	   *
	   * @private
	   * @param {Array|string} path The path of the property to get.
	   * @returns {Function} Returns the new function.
	   */
	  function basePropertyDeep(path) {
	    var pathKey = (path + '');
	    path = toPath(path);
	    return function(object) {
	      return baseGet(object, path, pathKey);
	    };
	  }

	  return basePropertyDeep;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(95), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseEach, isArrayLike) {

	  /**
	   * The base implementation of `_.map` without support for callback shorthands
	   * and `this` binding.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function baseMap(collection, iteratee) {
	    var index = -1,
	        result = isArrayLike(collection) ? Array(collection.length) : [];

	    baseEach(collection, function(value, key, collection) {
	      result[++index] = iteratee(value, key, collection);
	    });
	    return result;
	  }

	  return baseMap;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(96), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseForOwn, createBaseEach) {

	  /**
	   * The base implementation of `_.forEach` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array|Object|string} Returns `collection`.
	   */
	  var baseEach = createBaseEach(baseForOwn);

	  return baseEach;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(57), __webpack_require__(31)], __WEBPACK_AMD_DEFINE_RESULT__ = function(baseFor, keys) {

	  /**
	   * The base implementation of `_.forOwn` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Object} Returns `object`.
	   */
	  function baseForOwn(object, iteratee) {
	    return baseFor(object, iteratee, keys);
	  }

	  return baseForOwn;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(39), __webpack_require__(44), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function(getLength, isLength, toObject) {

	  /**
	   * Creates a `baseEach` or `baseEachRight` function.
	   *
	   * @private
	   * @param {Function} eachFunc The function to iterate over a collection.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {Function} Returns the new base function.
	   */
	  function createBaseEach(eachFunc, fromRight) {
	    return function(collection, iteratee) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        return eachFunc(collection, iteratee);
	      }
	      var index = fromRight ? length : -1,
	          iterable = toObject(collection);

	      while ((fromRight ? index-- : ++index < length)) {
	        if (iteratee(iterable[index], index, iterable) === false) {
	          break;
	        }
	      }
	      return collection;
	    };
	  }

	  return createBaseEach;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(68), __webpack_require__(69), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function(string, map, isArray) {
	    'use strict';
	    var css = {
	        namespaceSelector: namespaceSelector
	    };

	    return css;

	    /**
	     * Creates namespaced variants of the given selector(s) based on the given prefix paths.
	     * @param {(string|string[])} prefixPaths - camelCased.subPath or [camelCased.subPath, ..]
	     * @param {(string|string[])} [selectors] - Ex
	     * @returns {string}
	     */
	    function namespaceSelector(prefixPaths, selectors) {
	        prefixPaths = isArray(prefixPaths) ? prefixPaths : [prefixPaths];
	        var prefixes = map(prefixPaths, function(path) {
	            return string.dashCase(path);
	        });

	        if (!selectors) {
	            return prefixes.join(' ');
	        }

	        return map(isArray(selectors) ? selectors : selectors.split(' '), function(selector) {
	            selector = string.dashCase(selector);
	            return map(prefixes, function(prefix) {
	                if (!prefix) {
	                    return selector;
	                }

	                if (selector.indexOf('-') === 0) {
	                    return [prefix, selector].join('');
	                }

	                return [prefix, selector].join('-');
	            }).join(' ') + (prefixes.length && prefixes[0] ? ' ' + selector : '');
	        }).join(' ');
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(100), __webpack_require__(22), __webpack_require__(17), __webpack_require__(3), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Intl, each, isObject, extend, isString) {
	    var cache = {};
	    var _abbrs = {
	        thousands: {
	            pow10: 3,
	            next: 6
	        },
	        millions: {
	            pow10: 6,
	            next: 9
	        },
	        billions: {
	            pow10: 9,
	            next: 12
	        },
	        trillions: {
	            pow10: 12,
	            next: null
	        }
	    };

	    var _specialCurrencies = {
	        GBX: {
	            symbol: 'p',
	            name: 'pence'
	        }
	    };

	    var defaults = {
	        negativeTemplate: '-%v',
	        nullString: '-'
	    };

	    var regexMatchDigits = /([0-9,._' ]*[0-9])([\sa-zA-Z]*)$/;

	    return {
	        getFormatter: getNumberFormatter
	    };

	    function _buildKeySegments(segments, options) {
	        each(options, function(v, k) {
	            segments.push(k);
	            if (isObject(v)) {
	                _buildKeySegments(segments, v);
	            } else {
	                segments.push(v);
	            }
	        });
	    }

	    function parseFormatString(formatString) {
	        var result = {};
	        var parts = formatString.split('|');
	        each(parts, function(part) {
	            var segments = part.split(':');
	            if (segments.length !== 2) {
	                return;
	            }

	            segments[0] = segments[0].trim();
	            segments[1] = segments[1].trim();

	            switch (segments[0]) {
	                case 'abbr':
	                    result.abbreviate = result.abbreviate || {};
	                    result.abbreviate.mode = segments[1];
	                    break;
	                case 'dec':
	                    var fromTo = segments[1].split(',');
	                    result.minimumFractionDigits = parseInt(fromTo[0]);
	                    result.maximumFractionDigits = parseInt(fromTo[1]);
	                    break;
	                case 'style':
	                case 'currency':
	                case 'currencyDisplay':
	                    result[segments[0]] = segments[1];
	                    break;
	                default:
	                    throw new Error('Could not parse format string containing key: ' + segments[0]);
	            }
	        });

	        return result;
	    }

	    function getNumberFormatter(culture, options, formatAliases, abbreviations, defaultCurrencyId) {
	        options = options || {};
	        options = translateAlias(options, formatAliases);

	        if (options.formatString) {
	            options = extend(true, {}, options, parseFormatString(options.formatString));
	        }

	        options.currency = options.currency || defaultCurrencyId;
	        options.abbreviate = options.abbreviate || {};
	        options.abbreviate.abbreviations = options.abbreviate.abbreviations || abbreviations;

	        var key = [];
	        key.push(culture);
	        _buildKeySegments(key, options);
	        key = key.join('|');

	        if (!cache[key]) {
	            cache[key] = createFormatter(culture, options, formatAliases);
	        }

	        return cache[key];
	    }

	    function translateAlias(alias, formatAliases) {
	        if (!isString(alias)) {
	            return alias;
	        }

	        var result = formatAliases[alias];
	        if (!result) {
	            throw new Error('Could not find format alias: ' + alias);
	        }

	        return result;
	    }

	    function createFormatter(culture, options, formatAliases) {
	        options = extend({}, defaults, options || {});

	        if (options.style === 'currency' && _specialCurrencies[options.currency]) {
	            options.suffix = options.suffix || '';
	            options.currencyDisplay = options.currencyDisplay || 'symbol';

	            if (options.currencyDisplay === 'symbol' && _specialCurrencies[options.currency].symbol) {
	                options.suffix += _specialCurrencies[options.currency].symbol;
	            } else if (options.currencyDisplay === 'name' && _specialCurrencies[options.currency].name) {
	                options.suffix += ' ' + _specialCurrencies[options.currency].name;
	            } else { // code
	                options.suffix += ' ' + options.currency;
	            }

	            options.style = 'decimal';
	        }

	        // todo(slind): check options.culture if given?
	        var _intlNumberFormat = Intl.NumberFormat(culture, options);

	        var cache = {};

	        return {
	            format: function format(value, optionOverrides) {

	                if (optionOverrides && (isString(optionOverrides) || Object.keys(optionOverrides).length)) {
	                    optionOverrides = translateAlias(optionOverrides, formatAliases);

	                    var opts = extend(true, {}, options, optionOverrides);
	                    return getNumberFormatter(opts.culture || culture, opts).format(value);
	                }

	                if (value == null || isNaN(value)) {
	                    return options.nullString;
	                }

	                var cacheKey  = value ? value.toString() : 'null';
	                if (cache[cacheKey]) {
	                    return cache[cacheKey];
	                }

	                var abbr = null, prefix = options.prefix || '', suffix = options.suffix || '';

	                // abbreviate if specified
	                if (options.abbreviate && options.abbreviate.mode) {
	                    abbr = abbreviate(value, options);
	                    value = abbr.value;
	                    // prepend abbreviation suffix to the suffix
	                    suffix = abbr.abbreviation + suffix;
	                }

	                if (options.minimumFractionDigits > options.maximumFractionDigits) {
	                    options.maximumFractionDigits = options.minimumFractionDigits;
	                }

	                if (options.minimumSignificantDigits > options.maximumSignificantDigits) {
	                    options.maximumSignificantDigits = options.minimumSignificantDigits;
	                }

	                if (String(value).toLowerCase().indexOf('e') < 0 && (options.maximumFractionDigits || options.maximumSignificantDigits)) {
	                    value = Number(Math.round(100.0 * value + 'e' + (options.maximumFractionDigits || options.maximumSignificantDigits)) + 'e-' +
	                        (options.maximumFractionDigits || options.maximumSignificantDigits)) / 100.0;
	                }

	                var result;
	                if (value < 0 && options.negativeTemplate && options.negativeTemplate !== '-%v') {
	                    result = _intlNumberFormat.format(Math.abs(value));
	                    result = result.replace(regexMatchDigits, function(m, number, rest) {
	                        return options.negativeTemplate.replace('%v', number) + suffix + rest;
	                    });
	                } else {
	                    result = _intlNumberFormat.format(value);
	                    if (suffix) {
	                        result = result.replace(regexMatchDigits, function(m, number, rest) {
	                            return number + suffix + rest;
	                        });
	                    }
	                }

	                if (prefix) {
	                    result = prefix + result;
	                }

	                cache[cacheKey] = result;

	                return result;
	            }
	        };
	    }

	    function abbreviate(value, options) {
	        var abs = Math.abs(value),
	            abbr = '';

	        each(_abbrs, function(v, k) {
	            if (abbr) {
	                return;
	            }

	            // match abbr relevant to the value (mode: auto) OR forced by specific mode
	            if (_abbrModeMatch(abs, k, options.abbreviate.mode)) {
	                abbr = options.abbreviate.abbreviations[k];
	                value = value / Math.pow(10, v.pow10);
	            }
	        });

	        return {
	            value: value,
	            abbreviation: abbr
	        };
	    }

	    function _abbrModeMatch(abs, abbr, mode) {
	        var abbrDef = _abbrs[abbr];
	        return (abs >= Math.pow(10, abbrDef.pow10) && (abbrDef.next == null || Math.pow(10, abbrDef.next) > abs) &&
	            mode === 'auto') || mode === abbr;
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = Intl;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(100), __webpack_require__(22), __webpack_require__(17), __webpack_require__(3), __webpack_require__(11), __webpack_require__(14), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Intl, each, isObject, extend, isDate, isString, isNumber) {
	    var cache = {};
	    var valueCache = {};

	    var defaults = {
	        nullString: '-'
	    };

	    var _essentialProps = ['year', 'month', 'day', 'hour', 'minute', 'second'];

	    return {
	        getFormatter: getDateFormatter
	    };

	    function _buildKeySegments(segments, options) {
	        each(options, function(v, k) {
	            segments.push(k);
	            if (isObject(v)) {
	                _buildKeySegments(segments, v);
	            } else {
	                segments.push(v);
	            }
	        });
	    }

	    //function parseFormatString(formatString) {
	    //    var result = {};
	    //    var parts = formatString.split('|');
	    //    each(parts, function(part) {
	    //        var segments = part.split(':');
	    //        if (segments.length !== 2) {
	    //            return;
	    //        }
	    //
	    //        segments[0] = segments[0].trim();
	    //        segments[1] = segments[1].trim();
	    //
	    //        switch (segments[0]) {
	    //            case 'abbr':
	    //                result.abbreviate = result.abbreviate || {};
	    //                result.abbreviate.mode = segments[1];
	    //                break;
	    //            case 'dec':
	    //                var fromTo = segments[1].split(',');
	    //                result.minimumFractionDigits = parseInt(fromTo[0]);
	    //                result.maximumFractionDigits = parseInt(fromTo[1]);
	    //                break;
	    //            case 'style':
	    //            case 'currency':
	    //            case 'currencyDisplay':
	    //                result[segments[0]] = segments[1];
	    //                break;
	    //            default:
	    //                throw new Error('Could not parse format string containing key: ' + segments[0]);
	    //        }
	    //    });
	    //
	    //    return result;
	    //}

	    function getDateFormatter(culture, options, formatAliases) {
	        options = options || {};
	        options = translateAlias(options, formatAliases);

	        //if (options.formatString) {
	        //    options = extend(true, {}, options, parseFormatString(options.formatString));
	        //}

	        var key = [];
	        key.push(culture);
	        _buildKeySegments(key, options);
	        key = key.join('|');

	        if (!cache[key]) {
	            cache[key] = createFormatter(culture, options, formatAliases);
	        }

	        return cache[key];
	    }

	    function translateAlias(alias, formatAliases) {
	        if (!isString(alias)) {
	            return alias;
	        }

	        var result = formatAliases[alias];
	        if (!result) {
	            throw new Error('Could not find format alias: ' + alias);
	        }

	        return result;
	    }

	    function createFormatter(culture, options, formatAliases) {
	        options = extend({}, defaults, options || {});

	        // todo(slind): check options.culture if given?
	        var _intlDateFormat = Intl.DateTimeFormat(culture, options);

	        var cache = {};

	        return {
	            format: function format(value, optionOverrides) {
	                if (optionOverrides && (isString(optionOverrides) || Object.keys(optionOverrides).length)) {
	                    optionOverrides = translateAlias(optionOverrides, formatAliases);

	                    var hasEssentialProp = false;

	                    each(_essentialProps, function(prop) {
	                        if (optionOverrides.hasOwnProperty(prop)) {
	                            hasEssentialProp = true;
	                        }
	                    });

	                    var opts;
	                    if (hasEssentialProp === true) {
	                        opts = optionOverrides;
	                        if (!opts.nullString) {
	                            opts.nullString = options.nullString;
	                        }
	                    } else {
	                        opts = extend(true, {}, options, optionOverrides);
	                    }

	                    return getDateFormatter(opts.culture || culture, opts).format(value);
	                }

	                if (value == null) {
	                    return options.nullString;
	                }

	                var cacheKey  = value ? value.toString() : 'null';
	                if (cache[cacheKey]) {
	                    return cache[cacheKey];
	                }

	                if (!isDate(value)) {
	                    if (isString(value) || isNumber(value)) {
	                        value = valueCache[value] = valueCache[value] || new Date(value);
	                    } else {
	                        return cache[cacheKey] = value;
	                    }
	                }

	                var result = _intlDateFormat.format(value);

	                cache[cacheKey] = result;

	                return result;
	            }
	        };
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';

	    var hasConsole = !!console;

	    return {
	        debug: hasConsole ? debug : function() {},
	        info: hasConsole ? info : function() {},
	        error: hasConsole ? error : function() {}
	    };

	    function debug() {
	        console.debug.apply(console, arguments);
	    }

	    function info() {
	        console.info.apply(console, arguments);
	    }

	    function warn() {
	        console.warn.apply(console, arguments);
	    }

	    function error() {
	        console.error.apply(console, arguments);
	    }

	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29), __webpack_require__(14), __webpack_require__(22), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function(merge, isString, each, isPlainObject) {
	    return {
	        applyDefinitionsAndAliases: applyFieldDefinitionAndAliases,
	        applyDefinitionsAndAliasesToMany: applyMany
	    };

	    function applyMany(fields, fieldDefinitions, formatAliases) {
	        each(fields, function(field, key) {
	            fields[key] = applyFieldDefinitionAndAliases(field, fieldDefinitions, formatAliases);
	        });

	        return fields;
	    }

	    function applyFieldDefinitionAndAliases(field, fieldDefinitions, formatAliases) {
	        function mergeCustomizer(a, b, key) {
	            if (key === 'format') {
	                if (isPlainObject(b) && Object.keys(b).length < 2) {
	                    return;
	                }

	                var format = b || a;
	                if (isString(format)) {
	                    format = formatAliases[format];
	                }

	                return format || {};
	            }
	        }

	        if (!field) {
	            return field;
	        }

	        fieldDefinitions = fieldDefinitions || {};
	        formatAliases = formatAliases || {};

	        var result = field;
	        if (isString(field)) {
	            if (!fieldDefinitions[field]) {
	                throw new Error('Got field by name with missing field definition: ' + field);
	            }

	            if (field._hasInheritedFromFieldDefinition !== true) {
	                result = merge({}, fieldDefinitions[field], mergeCustomizer);
	                result.fieldId = field;
	                result.fieldName = result.fieldName || field;
	                result.format = result.format || {};
	                result._hasInheritedFromFieldDefinition = true;
	            }
	        } else if (field.fieldName) {
	            if (field._hasInheritedFromFieldDefinition !== true) {
	                result = merge({}, fieldDefinitions[field.fieldName], field, mergeCustomizer);
	                result.fieldId = field.fieldId || field.fieldName;
	                if (fieldDefinitions[field.fieldName] && fieldDefinitions[field.fieldName].fieldName) {
	                    result.fieldName = fieldDefinitions[field.fieldName].fieldName;
	                }

	                result.format = result.format || {};
	                result._hasInheritedFromFieldDefinition = true;
	            }
	        } else {
	            if (field._hasInheritedFromFieldDefinition !== true) {
	                result = merge({}, field, function(a, b, key) {
	                    if (key === 'format') {
	                        var format = b || a;
	                        if (isString(format)) {
	                            format = formatAliases[format];
	                        }

	                        return format || {};
	                    }
	                });
	                result.format = result.format || {};
	                result._hasInheritedFromFieldDefinition = true;
	            }
	        }

	        return result;
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(function(win) {

	    /**
	     * FastDom (customized so that it auto-flushes everything if in a test environment)
	     *
	     * Eliminates layout thrashing
	     * by batching DOM read/write
	     * interactions.
	     *
	     * @author Wilson Page <wilsonpage@me.com>
	     * @author Kornel Lesinski <kornel.lesinski@ft.com>
	     */

	    'use strict';

	    /**
	     * Mini logger
	     *
	     * @return {Function}
	     */
	    var debug = 0 ? console.log.bind(console, '[fastdom]') : function() {
	    };

	    /**
	     * Normalized rAF
	     *
	     * @type {Function}
	     */
	    var raf = win.requestAnimationFrame
	        || win.webkitRequestAnimationFrame
	        || win.mozRequestAnimationFrame
	        || win.msRequestAnimationFrame
	        || function(cb) {
	            return setTimeout(cb, 16);
	        };

	    /**
	     * Initialize a `FastDom`.
	     *
	     * @constructor
	     */
	    function FastDom() {
	        var self = this;
	        self.reads = [];
	        self.writes = [];
	        self.raf = raf.bind(win); // test hook
	        debug('initialized', self);
	    }

	    function isTestEnvironment() {
	        return win && win.__karma__;
	    }

	    FastDom.prototype = {
	        constructor: FastDom,

	        /**
	         * Adds a job to the read batch and
	         * schedules a new frame if need be.
	         *
	         * @param  {Function} fn
	         * @public
	         */
	        measure: function(fn, ctx) {
	            if (isTestEnvironment()) {
	                fn();
	                return;
	            }

	            debug('measure');
	            var task = !ctx ? fn : fn.bind(ctx);
	            this.reads.push(task);
	            scheduleFlush(this);
	            return task;
	        },

	        /**
	         * Adds a job to the
	         * write batch and schedules
	         * a new frame if need be.
	         *
	         * @param  {Function} fn
	         * @public
	         */
	        mutate: function(fn, ctx) {
	            if (isTestEnvironment()) {
	                fn();
	                return;
	            }

	            debug('mutate');
	            var task = !ctx ? fn : fn.bind(ctx);
	            this.writes.push(task);
	            scheduleFlush(this);
	            return task;
	        },

	        /**
	         * Clears a scheduled 'read' or 'write' task.
	         *
	         * @param {Object} task
	         * @return {Boolean} success
	         * @public
	         */
	        clear: function(task) {
	            debug('clear', task);
	            return remove(this.reads, task) || remove(this.writes, task);
	        },

	        /**
	         * Extend this FastDom with some
	         * custom functionality.
	         *
	         * Because fastdom must *always* be a
	         * singleton, we're actually extending
	         * the fastdom instance. This means tasks
	         * scheduled by an extension still enter
	         * fastdom's global task queue.
	         *
	         * The 'super' instance can be accessed
	         * from `this.fastdom`.
	         *
	         * @example
	         *
	         * var myFastdom = fastdom.extend({
	   *   initialize: function() {
	   *     // runs on creation
	   *   },
	   *
	   *   // override a method
	   *   measure: function(fn) {
	   *     // do extra stuff ...
	   *
	   *     // then call the original
	   *     return this.fastdom.measure(fn);
	   *   },
	   *
	   *   ...
	   * });
	         *
	         * @param  {Object} props  properties to mixin
	         * @return {FastDom}
	         */
	        extend: function(props) {
	            debug('extend', props);
	            if (typeof props != 'object') {
	                throw new Error('expected object');
	            }

	            var child = Object.create(this);
	            mixin(child, props);
	            child.fastdom = this;

	            // run optional creation hook
	            if (child.initialize) {
	                child.initialize();
	            }

	            return child;
	        },

	        // override this with a function
	        // to prevent Errors in console
	        // when tasks throw
	        catch: null
	    };

	    /**
	     * Schedules a new read/write
	     * batch if one isn't pending.
	     *
	     * @private
	     */
	    function scheduleFlush(fastdom) {
	        if (!fastdom.scheduled) {
	            fastdom.scheduled = true;
	            fastdom.raf(flush.bind(null, fastdom));
	            debug('flush scheduled');
	        }
	    }

	    /**
	     * Runs queued `read` and `write` tasks.
	     *
	     * Errors are caught and thrown by default.
	     * If a `.catch` function has been defined
	     * it is called instead.
	     *
	     * @private
	     */
	    function flush(fastdom) {
	        debug('flush');

	        var writes = fastdom.writes;
	        var reads = fastdom.reads;
	        var error;

	        try {
	            debug('flushing reads', reads.length);
	            runTasks(reads);
	            debug('flushing writes', writes.length);
	            runTasks(writes);
	        } catch (e) {
	            error = e;
	        }

	        fastdom.scheduled = false;

	        // If the batch errored we may still have tasks queued
	        if (reads.length || writes.length) {
	            scheduleFlush(fastdom);
	        }

	        if (error) {
	            debug('task errored', error.message);
	            if (fastdom.catch) {
	                fastdom.catch(error);
	            } else {
	                throw error;
	            }
	        }
	    }

	    /**
	     * We run this inside a try catch
	     * so that if any jobs error, we
	     * are able to recover and continue
	     * to flush the batch until it's empty.
	     *
	     * @private
	     */
	    function runTasks(tasks) {
	        debug('run tasks');
	        var task;
	        while (task = tasks.shift()) {
	            task();
	        }
	    }

	    /**
	     * Remove an item from an Array.
	     *
	     * @param  {Array} array
	     * @param  {*} item
	     * @return {Boolean}
	     */
	    function remove(array, item) {
	        var index = array.indexOf(item);
	        return !!~index && !!array.splice(index, 1);
	    }

	    /**
	     * Mixin own properties of source
	     * object into the target.
	     *
	     * @param  {Object} target
	     * @param  {Object} source
	     */
	    function mixin(target, source) {
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                target[key] = source[key];
	            }
	        }
	    }

	// There should never be more than
	// one instance of `FastDom` in an app
	    var exports = new FastDom(); // jshint ignore:line

	// Expose to CJS & AMD
	    if (("function")[0] == 'f') {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return exports;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module)[0] == 'o') {
	        module.exports = exports;
	    }

	})(window || this);


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation) {
	    'use strict';
	    validation.addValidationRule('required', {
	        type: 'custom',
	        runFalsy: true,
	        execute: function(val, options) {
	            return typeof val !== 'undefined' && val !== null && val !== '';
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation) {
	    'use strict';
	    validation.addCustomValidationRule('range', function(val, options) {
	        return (!options.hasOwnProperty('min') || val >= options.min) &&
	            (!options.hasOwnProperty('max') || val <= options.max);
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation) {
	    'use strict';
	    validation.addCustomValidationRule('integer', function(val, options) {
	        return val % 1 === 0;
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation, util) {
	    'use strict';
	    var cache = {};

	    function createAndCacheRegex(pattern) {
	        if (util.isString(pattern)) {
	            if (cache[pattern]) {
	                pattern = cache[pattern];
	            } else {
	                pattern = cache[pattern] = new RegExp(pattern);
	            }
	        } else {
	            throw new Error('invalid regex pattern');
	        }

	        return pattern;
	    }

	    validation.addCustomValidationRule('regex', function(val, options) {
	        if (!options.pattern) {
	            throw new Error('regex validator requires a pattern');
	        }

	        var regex = options.pattern;
	        if (!util.isRegex(regex)) {
	            regex = createAndCacheRegex(regex);
	        }

	        return regex.test(val);
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation) {
	    'use strict';
	    validation.addValidationRule('alpha', {
	        type: 'regex',
	        pattern: /^([A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$/
	    });

	    validation.addValidationRule('alphaSpaces', {
	        type: 'regex',
	        pattern: /^([A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s])+$/
	    });

	    validation.addValidationRule('alphaNumeric', {
	        type: 'regex',
	        pattern: /^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$/
	    });

	    validation.addValidationRule('alphaNumSpaces', {
	        type: 'regex',
	        pattern: /^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s])+$/
	    });

	    validation.addValidationRule('alphaDash', {
	        type: 'regex',
	        pattern: /^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ_-])+$/
	    });

	    validation.addValidationRule('alphaDashSpaces', {
	        type: 'regex',
	        pattern: /^([A-Za-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\s_-])+$/
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(validation, util) {
	    'use strict';
	    validation.addCustomValidationRule('equality', function(val, options) {
	        return util.isEqual(val, options.compareTo);
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(util, extend) {
	    'use strict';

	    /**
	     * Represents namespacing for morningstar components. All components may
	     * register themselves using morningstar.asterix.register. This will make them
	     * available under the morningstar.components global.
	     *
	     * @class
	     * @constructor
	     * @author dcolli1
	     * @modifier jou - removed class and constuctor.
	     */
	    return (function() {
	        var _morningstarNoConflict;

	        init();

	        return {
	            init: init,
	            register: register,
	            reset: reset,
	            noConflict: noConflict,
	            getDefaultConfig: getDefaultConfig
	        };

	        function init() {
	            _morningstarNoConflict = window.morningstar; //todo i think we need to use cloneOjb here.

	            window.morningstar = window.morningstar || {};
	            if (!window.morningstar.asterix) {
	                var morningstarRoot = extend(true, {}, {
	                    name: 'morningstar',
	                    asterix: {},
	                    components: {
	                        _defaultConfig: {},
	                        _appConfig: {
	                            settings: {},
	                            components: {}
	                        }
	                    }
	                }, window.morningstar);

	                window.morningstar = morningstarRoot;
	            } else {
	                util.log.debug('Tried to create morningstar.asterix multiple times.');
	            }
	        }

	        /**
	         * Registers a new component
	         * @param {string} name - The component name to register
	         * @param {object} defaultConfig - The default component configuration
	         * @return {object} components namespace
	         */
	        function register(name, defaultConfig) {
	            var parts = name.split('.');

	            if (parts[0] === window.morningstar.name) {
	                parts = parts.slice(1);
	            }

	            if (parts[0] === 'components') {
	                parts = parts.slice(1);
	            }

	            var partsLength = parts.length,
	                parent = window.morningstar.components;

	            for (var m = 0; m < partsLength; m++) {
	                if (typeof parent[parts[m]] === 'undefined') {
	                    parent[parts[m]] = {};
	                }

	                parent = parent[parts[m]];
	            }

	            if (defaultConfig) {
	                // register default config for component type, if given
	                var type = parts.join('.');
	                window.morningstar.components.defaultConfig = window.morningstar.components.defaultConfig || {};
	                parent.defaultConfig = window.morningstar.components._defaultConfig[type] = defaultConfig;
	                parent.defaultConfig.type = type;
	                parent.instances = {};
	                parent.registerInstance = function registerInstance(modulePath, instanceConfig) {
	                    instanceConfig = instanceConfig || {};
	                    instanceConfig.type = type;
	                    parent.instances[modulePath] = instanceConfig;
	                    util.componentPath.assignInstance(modulePath, window.morningstar.components._appConfig, window.morningstar.components._defaultConfig, type, instanceConfig, null);
	                };
	            }

	            return window.morningstar;
	        }

	        function getDefaultConfig(type) {
	            if (!type) {
	                return window.morningstar.components._defaultConfig || {};
	            } else {
	                return (window.morningstar.components._defaultConfig || {})[type];
	            }
	        }

	        /**
	         *
	         * @return {object}
	         */
	        function noConflict() {
	            window[window.morningstar.name] = _morningstarNoConflict;
	            return window.morningstar;
	        }

	        function reset() {
	            window.morningstar.components = {
	                _defaultConfig: {},
	                _appConfig: {
	                    settings: {},
	                    components: {}
	                }
	            };
	        }

	    }());

	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(111), __webpack_require__(3), __webpack_require__(113), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(namespace, extend, formatting, util) {
	    'use strict';

	    var defaultConfiguration = null,
	        applicationConfiguration = null,
	        baseLabels = null,
	        baseSettings = null,
	        options,
	        _componentInstanceConfigCache = {},
	        componentInstanceSettingsCache = {},
	        componentInstanceLabelsCache = {},
	        componentInstanceLanguageLabelsCache = {},
	        componentInstanceTypeCache = {},
	        modulePaths = {},
	        _defaultConfigFragmentCache = {},
	        _defaultSettingsFragmentCache = {},
	        _instanceSettingsFragmentCache = {},
	        _defaultLabelsFragmentCache = {},
	        _instanceLabelsFragmentCache = {},
	        _typeConfigs = {};

	    var defaultBaseLabels = __webpack_require__(114);
	    var defaultBaseSettings = __webpack_require__(115);

	    function getNonUnderscored(obj) {
	        var newObj = {};
	        util.each(obj, function(v, k) {
	            if (k.charAt(0) !== '_') {
	                newObj[k] = v;
	            }
	        });

	        return newObj;
	    }

	    function getUnderscored(obj) {
	        var newObj = {};
	        util.each(obj, function(v, k) {
	            if (k.charAt(0) === '_') {
	                newObj[k] = v;
	            }
	        });

	        return newObj;
	    }

	    function mergeCustomizer(a, b, key) {
	        if (util.isArray(b)) {
	            return b;
	        }
	    }

	    function mergeCustomizerExceptUnderscore(a, b, key) {
	        if (key && util.isString(key) && key.charAt(0) === '_') {
	            return a;
	        }

	        if (util.isArray(b)) {
	            return b;
	        }
	    }

	    function _applyEnv(obj, path) {
	        path = path || '';
	        if (path.indexOf('settings') >= 0 && obj.__env) {
	            var env = obj.__env[options.env];
	            if (env) {
	                util.merge(obj, env);
	            }
	        }

	        util.each(obj, function(v, k) {
	            if (util.isPlainObject(v) && ['labels'].indexOf(k) < 0) {
	                obj[k] = _applyEnv(v, path ? path + '.' + k : k);
	            }
	        });

	        return obj;
	    }

	    function defaultConfigCacher(path, type, currentDefaultConfig) {
	        if (_defaultConfigFragmentCache[path]) {
	            return _defaultConfigFragmentCache[path];
	        }

	        var typeExtended = defaultConfiguration[type] || {};
	        return _defaultConfigFragmentCache[path] = util.merge({}, typeExtended, currentDefaultConfig, mergeCustomizer);
	    }

	    function defaultSettingsCacher(path, currentDefaultSettings, currentDefaultConfig) {
	        if (_defaultSettingsFragmentCache[path]) {
	            return _defaultSettingsFragmentCache[path];
	        }

	        return _defaultSettingsFragmentCache[path] = util.merge({}, getNonUnderscored(currentDefaultSettings), currentDefaultConfig &&
	            currentDefaultConfig.settings ? currentDefaultConfig.settings : {}, mergeCustomizer);
	    }

	    function instanceSettingsCacher(path, currentInstance, currentSettings, currentDefaultSettings) {
	        if (_instanceSettingsFragmentCache[path]) {
	            return _instanceSettingsFragmentCache[path];
	        }

	        return _instanceSettingsFragmentCache[path] = util.merge({}, util.merge({}, getUnderscored(currentDefaultSettings), getUnderscored(
	            currentInstance.settings), mergeCustomizer), getNonUnderscored(currentSettings), currentInstance.settings, mergeCustomizerExceptUnderscore);
	    }

	    function defaultLabelsCacher(path, currentDefaultLabels, currentDefaultConfig) {
	        if (_defaultLabelsFragmentCache[path]) {
	            return _defaultLabelsFragmentCache[path];
	        }

	        return _defaultLabelsFragmentCache[path] = util.merge({}, getNonUnderscored(currentDefaultLabels), currentDefaultConfig && currentDefaultConfig.labels ?
	            currentDefaultConfig.labels : {}, mergeCustomizer);
	    }

	    function instanceLabelsCacher(path, currentInstance, currentLabels, currentDefaultLabels) {
	        if (_instanceLabelsFragmentCache[path]) {
	            return _instanceLabelsFragmentCache[path];
	        }

	        return _instanceLabelsFragmentCache[path] = util.merge({}, util.merge({}, getUnderscored(currentDefaultLabels), getUnderscored(
	            currentInstance.labels), mergeCustomizer), getNonUnderscored(currentLabels), currentInstance.labels, mergeCustomizerExceptUnderscore);
	    }

	    function storeTypeConfigs(typeConfigs) {
	        util.each(typeConfigs, function(typeConfig, type) {
	            if (_typeConfigs[type]) {
	                _typeConfigs[type] = util.merge({}, _typeConfigs[type], typeConfig);
	            } else {
	                _typeConfigs[type] = typeConfig;
	            }
	        });
	    }

	    function getComponentInstanceConfig(modulePath) {
	        if(_componentInstanceConfigCache[modulePath]) {
	            return _componentInstanceConfigCache[modulePath];
	        }

	        var currentInstanceConfig = applicationConfiguration,
	            currentSettings = currentInstanceConfig.settings,
	            currentLabels = currentInstanceConfig.labels,
	            currentDefaultConfig = {},
	            currentDefaultSettings = {},
	            currentDefaultLabels = {},
	            currentType;

	        var paths = modulePath.split('.');
	        var currFull = '';

	        for (var i = 0; i < paths.length; i++) {
	            var pathFragment = paths[i];
	            currFull += (currFull ? '.' : '') + pathFragment;

	            currentInstanceConfig = currentInstanceConfig.components &&
	                currentInstanceConfig.components[pathFragment] ?
	                currentInstanceConfig.components[pathFragment] : {};

	            currentDefaultConfig = currentDefaultConfig && currentDefaultConfig.components &&
	                currentDefaultConfig.components[pathFragment] ?
	                currentDefaultConfig.components[pathFragment] : {};

	            currentType = currentInstanceConfig.type || currentDefaultConfig.type;

	            currentDefaultConfig = defaultConfigCacher(currFull, currentType, currentDefaultConfig);
	            currentInstanceConfig = instanceConfigCacher(currFull, currentInstanceConfig, currentDefaultConfig, currentType);

	            // cache/get default settings and labels
	            currentInstanceConfig.defaultSettings = currentDefaultSettings = defaultSettingsCacher(currFull, currentDefaultSettings, currentDefaultConfig);
	            currentInstanceConfig.defaultLabels = currentDefaultLabels = defaultLabelsCacher(currFull, currentDefaultLabels, currentDefaultConfig);

	            // cache/get instance settings and labels
	            currentInstanceConfig.settings = currentSettings = instanceSettingsCacher(currFull, currentInstanceConfig, currentSettings, currentDefaultSettings);
	            currentInstanceConfig.labels = currentLabels = instanceLabelsCacher(currFull, currentInstanceConfig, currentLabels, currentDefaultLabels);

	            componentInstanceTypeCache[currFull] = currentType;
	            if (!componentInstanceTypeCache[currFull]) {
	                throw new Error('Invalid component type for modulePath: ' + currFull);
	            }
	        }
	        return currentInstanceConfig;
	    }

	    function instanceConfigCacher(currFull, currentInstanceConfig, currentDefaultConfig, currentType) {
	        if(_componentInstanceConfigCache[currFull]) {
	             return _componentInstanceConfigCache[currFull];
	        }

	        if(currentDefaultConfig.types) {
	            storeTypeConfigs(currentDefaultConfig.types);
	        }
	        if (currentDefaultConfig.blueprints && currentInstanceConfig.blueprint && currentDefaultConfig.blueprints[currentInstanceConfig.blueprint]) {
	            var blueprintConfig = currentDefaultConfig.blueprints[currentInstanceConfig.blueprint];
	            currentInstanceConfig = morningstar.asterix.util.merge({}, blueprintConfig, currentInstanceConfig, mergeCustomizer);
	        }

	        if(currentInstanceConfig.types) {
	            storeTypeConfigs(currentInstanceConfig.types);
	        }
	        if(_typeConfigs[currentType]) {
	            currentInstanceConfig = morningstar.asterix.util.merge({}, _typeConfigs[currentType], currentInstanceConfig, mergeCustomizer);
	        }

	        _componentInstanceConfigCache[currFull] = currentInstanceConfig;
	        return _componentInstanceConfigCache[currFull];
	    }

	    function getComponentInstanceSettings(modulePath) {
	        if (componentInstanceSettingsCache[modulePath]) {
	            return componentInstanceSettingsCache[modulePath];
	        }

	        var instanceConfig = getComponentInstanceConfig(modulePath);

	        var currentDefaultSettings = util.merge({}, baseSettings, instanceConfig.defaultSettings, instanceConfig.settings, mergeCustomizer);

	        // in case we rely on inherited default settings we fallback to currentDefaultConfig.type
	        componentInstanceSettingsCache[modulePath] = getModuleSpecificInstanceSettings(currentDefaultSettings,
	            componentInstanceTypeCache[modulePath]);
	        return componentInstanceSettingsCache[modulePath];
	    }

	    var autoInherit = ['languageId', 'currencyId', 'currencySymbol', 'defaultNumberFormat', 'defaultDateFormat',
	        'format',
	        'validation', '_validation'
	    ];

	    function shouldAutoInherit(key) {
	        return autoInherit.indexOf(key) > -1;
	    }

	    function getModuleSpecificInstanceSettings(settings, moduleType) {
	        var defaultSettings = defaultConfiguration[moduleType] &&
	            defaultConfiguration[moduleType].settings ? defaultConfiguration[moduleType].settings : {};

	        var keys = Object.keys(settings);
	        for (var i = 0; i < keys.length; i++) {
	            if (defaultSettings[keys[i]] === undefined &&
	                (!defaultSettings.__allowed || defaultSettings.__allowed.indexOf(keys[i]) < 0) &&
	                !shouldAutoInherit(keys[i])) {
	                delete settings[keys[i]];
	            }
	        }

	        return settings;
	    }

	    function getComponentInstanceLabels(modulePath, languageId) {
	        var moduleSpecificInstanceLabels = componentInstanceLabelsCache[modulePath];
	        if (!moduleSpecificInstanceLabels) {

	            var instanceConfig = getComponentInstanceConfig(modulePath);
	            var currentDefaultLabels = util.merge({}, instanceConfig.defaultLabels, instanceConfig.labels, mergeCustomizer);

	            moduleSpecificInstanceLabels = currentDefaultLabels;
	            componentInstanceLabelsCache[modulePath] = moduleSpecificInstanceLabels;
	        }

	        var languageLabels = componentInstanceLanguageLabelsCache[modulePath] &&
	            componentInstanceLanguageLabelsCache[modulePath][languageId] ?
	            componentInstanceLanguageLabelsCache[modulePath][languageId] : null;
	        if (!languageLabels) {
	            languageLabels = {};

	            // todo: fix implementation to support x1-x2-x3-x4-x5-..-xn
	            var baseLanguage = null;
	            if (languageId.split('-').length > 1) {
	                baseLanguage = languageId.split('-')[0];
	            }

	            var finalLabels = extend(true, {}, baseLabels, moduleSpecificInstanceLabels);

	            util.each(finalLabels, function(moduleSpecificInstanceLabelValue, moduleSpecificInstanceLabelKey) {
	                if (!moduleSpecificInstanceLabelValue) {
	                    return;
	                }

	                if (moduleSpecificInstanceLabelValue[languageId]) {
	                    languageLabels[moduleSpecificInstanceLabelKey] = moduleSpecificInstanceLabelValue[languageId];
	                } else if (baseLanguage && moduleSpecificInstanceLabelValue[baseLanguage]) {
	                    languageLabels[moduleSpecificInstanceLabelKey] = moduleSpecificInstanceLabelValue[baseLanguage];
	                } else if (moduleSpecificInstanceLabelValue.en) {
	                    // default to en if no label found for languageId
	                    languageLabels[moduleSpecificInstanceLabelKey] = moduleSpecificInstanceLabelValue.en;
	                }
	            });

	            if (!componentInstanceLanguageLabelsCache[modulePath]) {
	                componentInstanceLanguageLabelsCache[modulePath] = {};
	            }

	            componentInstanceLanguageLabelsCache[modulePath][languageId] = languageLabels;
	        }

	        return languageLabels;
	    }

	    function getComponentInstanceType(modulePath) {
	        if (componentInstanceTypeCache[modulePath]) {
	            return componentInstanceTypeCache[modulePath];
	        }

	        var currentInstance = applicationConfiguration,
	            currentDefaultConfig = {},
	            currType;

	        var paths = modulePath.split('.');
	        for (var i = 0; i < paths.length; i++) {
	            var componentInstanceId = paths[i];
	            currentInstance = currentInstance.components &&
	                currentInstance.components[componentInstanceId] ?
	                currentInstance.components[componentInstanceId] : {};
	            currentDefaultConfig = currentDefaultConfig && currentDefaultConfig.components &&
	                currentDefaultConfig.components[componentInstanceId] ?
	                currentDefaultConfig.components[componentInstanceId] : (!currentInstance.type ? {} : defaultConfiguration[currentInstance.type]);
	            currType = currentInstance.type || currentDefaultConfig.type;
	            currentDefaultConfig.components = extend({}, currentDefaultConfig.components, !currType ? {} : defaultConfiguration[currType].components);
	        }

	        componentInstanceTypeCache[modulePath] = currType;

	        return componentInstanceTypeCache[modulePath];
	    }

	    function getSetting(modulePath, settingKey) {
	        return getComponentInstanceSettings(modulePath)[settingKey];
	    }

	    function init(applicationConfig, defaultConfig, baseLabelsIn, baseSettingsIn, optionsIn) {
	        if (!applicationConfig) {
	            throw new Error('(config) No applicationConfig provided');
	        }

	        if (!defaultConfig) {
	            throw new Error('(config) No defaultConfig provided');
	        }

	        _componentInstanceConfigCache = {};
	        componentInstanceSettingsCache = {};
	        componentInstanceLabelsCache = {};
	        componentInstanceLanguageLabelsCache = {};
	        componentInstanceTypeCache = {};
	        modulePaths = {};
	        _defaultConfigFragmentCache = {};
	        _defaultSettingsFragmentCache = {};
	        _instanceSettingsFragmentCache = {};
	        _defaultLabelsFragmentCache = {};
	        _instanceLabelsFragmentCache = {};
	        applicationConfiguration = applicationConfig;
	        defaultConfiguration = defaultConfig;
	        baseLabels = extend(true, {}, defaultBaseLabels, baseLabelsIn);
	        baseSettings = extend({}, defaultBaseSettings, baseSettingsIn);
	        options = optionsIn || {};
	        if (!options.hasOwnProperty('dynamic')) {
	            options.dynamic = false;
	        }

	        util.each(Object.keys(baseSettings), function(key) {
	            if (autoInherit.indexOf(key) < 0) {
	                autoInherit.push(key);
	            }
	        });

	        _applyEnv(applicationConfiguration);
	        _applyEnv(defaultConfiguration);

	        registerModulePaths(applicationConfig.components);
	    }

	    function registerModulePaths(components, pathPrefix) {
	        if (Object.keys(components).length === 0) {
	            return;
	        }

	        util.each(components, function(component, pathFragment) {
	            var fullPath = (pathPrefix ? pathPrefix + '.' : '') + pathFragment;
	            if (!modulePaths.hasOwnProperty(fullPath)) {
	                modulePaths[fullPath] = true;
	            }

	            if (!component.type) {
	                throw new Error('Missing component type for path: ' + fullPath);
	            }

	            registerModulePaths(extend({}, defaultConfiguration.hasOwnProperty(component.type) ?
	                defaultConfiguration[component.type].components : {}, component.components), fullPath);
	        });
	    }

	    function getModulePaths() {
	        return modulePaths;
	    }

	    function getComponentType(modulePath) {
	        return getComponentInstanceType(modulePath);
	    }

	    function hasType(type) {
	        return !!defaultConfiguration[type];
	    }

	    function hasInstance(modulePath) {
	        return !!modulePaths[modulePath];
	    }

	    function _addInstance(modulePath, opts) {
	        if (!modulePath || !opts || !opts.type) {
	            throw new Error('(config) _addInstance requires modulePath and opts (with type)');
	        }

	        util.componentPath.assignInstance(modulePath, applicationConfiguration, defaultConfiguration, opts.type, opts.instanceConfig, function(modulePath) {
	            modulePaths[modulePath] = true;

	            // invalidate fragment cache for ancestors
	            util.each([_defaultConfigFragmentCache, _defaultLabelsFragmentCache, _defaultSettingsFragmentCache, _instanceLabelsFragmentCache, _instanceSettingsFragmentCache, _componentInstanceConfigCache], function(cache, key) {
	                util.each(cache, function(entry, key) {
	                    if (modulePath.indexOf(key) === 0) {
	                        delete cache[key];
	                    }
	                });
	            });
	        });
	    }

	    function allowsDynamic() {
	        return !options || options.dynamic;
	    }

	    function addType(type, defaultConfig) {
	        if (!allowsDynamic()) {
	            throw new Error('(config) The configuration module has been configured not to allow dynamic behaviour.');
	        }

	        defaultConfig = defaultConfig || namespace.getDefaultConfig(type);

	        if (!type || !defaultConfig) {
	            throw new Error('(config) _addType requires type and defaultConfig');
	        }

	        if (!defaultConfig.type) {
	            defaultConfig.type = type;
	        }

	        defaultConfiguration[type] = defaultConfig;
	    }

	    function addInstance(modulePath, opts) {
	        if (!canAddModulePathDynamically(modulePath)) {
	            throw new Error('(config) The configuration module has been configured not to allow dynamic behaviour.');
	        }

	        if (!modulePath || !opts) {
	            throw new Error('(config) addInstance requires modulePath and options');
	        }

	        if (!opts.type) {
	            throw new Error('(config) addInstance requires options.type');
	        }

	        if (!hasType(opts.type)) {
	            addType(opts.type, opts.defaultConfig);
	        }

	        if (!hasInstance(modulePath)) {
	            _addInstance(modulePath, opts);
	        }
	    }

	    function canAddModulePathDynamically(modulePath) {
	        return allowsDynamic() || (modulePath && modulePath.indexOf('[') >= 0 &&
	            hasInstance(modulePath.substring(0, modulePath.lastIndexOf('['))));
	    }

	    return {
	        init: init,
	        getSetting: getSetting,
	        getSettings: getComponentInstanceSettings,
	        getLabels: getComponentInstanceLabels,
	        getComponentType: getComponentType,
	        getModulePaths: getModulePaths,
	        addType: addType,
	        addInstance: addInstance,
	        hasType: hasType,
	        hasInstance: hasInstance,
	        canAddModulePathDynamically: canAddModulePathDynamically,
	        allowsDynamic: allowsDynamic,
	        /**
	         * Note: instanceId can only be a top level instance.
	         * @param instanceId
	         * @returns {*}
	         */
	        getInstanceConfig: function getDefaultConfig(instanceId) {
	            return !applicationConfiguration || !applicationConfiguration.components ||
	                !applicationConfiguration.components[instanceId] ? null :
	                applicationConfiguration.components[instanceId];
	        },
	        getDefaultConfig: function getDefaultConfig(type) {
	            return !defaultConfiguration || !defaultConfiguration[type] ? null : defaultConfiguration[type];
	        },
	        getOption: function getOption(key) {
	            return (options || {})[key];
	        },
	        setOption: function setOption(key, value) {
	            options = options || {};
	            options[key] = value;
	        },
	        getBaseSettings: function getBaseSettings() {
	            return defaultBaseSettings;
	        },
	        mergeBaseSettings: function mergeBaseSettings(settings) {
	            defaultBaseSettings = util.merge({}, defaultBaseSettings, settings);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(extend, util) {
	    'use strict';

	    function getFormatter(languageId, opts, formatAliases, numberAbbreviations, defaultNumberCurrencyId) {
	        if (!languageId) {
	            throw new Error('getFormatter expects languageId');
	        }

	        opts = extend(true, {
	            number: {
	            },
	            date: {
	            },
	            any: {
	                number: {
	                },
	                date: {
	                }
	            }
	        }, opts);

	        var numberFormatter = util.intlNumberFormat.getFormatter(languageId, opts.number, formatAliases, numberAbbreviations, defaultNumberCurrencyId).format;
	        var anyFormatter = function(value, optionOverrides) {
	            var result = value;
	            optionOverrides = util.isString(optionOverrides) ? formatAliases[optionOverrides] : optionOverrides;
	            optionOverrides = optionOverrides || {};
	            var nullString = optionOverrides.optionOverrides || opts.any.nullString;
	            if (util.isNumber(value)) {
	                result = util.intlNumberFormat.getFormatter(languageId, opts.any.number, formatAliases, numberAbbreviations, defaultNumberCurrencyId).format(value, optionOverrides.number);
	            } else if (util.isDate(value)) {
	                result = util.intlDateFormat.getFormatter(languageId, opts.any.date, formatAliases).format(value, optionOverrides.date);
	            } else {
	                result = result || nullString;
	            }
	            return result;
	        };

	        var currencySymbol = function(currency, mode) {
	            var modes = ['symbol', 'code', 'name'];

	            if (modes.indexOf(mode) < 0) {
	                mode = modes[0];
	            }

	            var opts = {
	                style: 'currency',
	                currency: currency || defaultNumberCurrencyId || 'GBP',
	                currencyDisplay: mode,
	                minimumFractionDigits: 0,
	                maximumFractionDigits: 0
	            };

	            return numberFormatter(0, opts).replace('0', '').trim();
	        };

	        return {
	            getOptionValue: function(key) {
	                return opts[key];
	            },
	            number: numberFormatter,
	            date: util.intlDateFormat.getFormatter(languageId, opts.date, formatAliases).format,
	            currencySymbol: currencySymbol,
	            any: anyFormatter
	        };
	    }

	    return {
	        getFormatter: getFormatter
	    };

	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = {
		"thousands": {
			"en": "k"
		},
		"millions": {
			"en": "m"
		},
		"billions": {
			"en": "b"
		},
		"trillions": {
			"en": "t"
		},
		"largeValue": {
			"en": "Large Value"
		},
		"largeBlend": {
			"en": "Large Blend"
		},
		"largeGrowth": {
			"en": "Large Growth"
		},
		"midValue": {
			"en": "Mid Value"
		},
		"midBlend": {
			"en": "Mid Blend"
		},
		"midGrowth": {
			"en": "Mid Growth"
		},
		"smallValue": {
			"en": "Small Value"
		},
		"smallBlend": {
			"en": "Small Blend"
		},
		"smallGrowth": {
			"en": "Small Growth"
		},
		"january": {
			"en": "January"
		},
		"february": {
			"en": "February"
		},
		"march": {
			"en": "March"
		},
		"april": {
			"en": "April"
		},
		"may": {
			"en": "May"
		},
		"june": {
			"en": "June"
		},
		"july": {
			"en": "July"
		},
		"august": {
			"en": "August"
		},
		"september": {
			"en": "September"
		},
		"october": {
			"en": "October"
		},
		"november": {
			"en": "November"
		},
		"december": {
			"en": "December"
		},
		"basicMaterial": {
			"en": "Basic Material"
		},
		"communicationServices": {
			"en": "Communication Services"
		},
		"consumerCyclical": {
			"en": "Consumer Cyclical"
		},
		"consumerDefensive": {
			"en": "Consumer Defensive"
		},
		"energy": {
			"en": "Energy"
		},
		"financialServices": {
			"en": "Financial Services"
		},
		"healthcare": {
			"en": "Healthcare"
		},
		"industrials": {
			"en": "Industrials"
		},
		"realEstate": {
			"en": "Real Estate"
		},
		"technology": {
			"en": "Technology"
		},
		"utilities": {
			"en": "Utilities"
		}
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = {
		"languageId": "en-GB",
		"currencyId": "GBP",
		"format": {
			"nullString": "-",
			"any": {
				"dataType": "any",
				"number": {
					"dataType": "number",
					"style": "decimal",
					"useGrouping": true,
					"minimumFractionDigits": 0,
					"maximumFractionDigits": 2,
					"abbreviate": {},
					"nullString": "-"
				},
				"date": {
					"dataType": "date",
					"year": "numeric",
					"month": "numeric",
					"day": "numeric",
					"nullString": "-"
				},
				"nullString": "-"
			},
			"number": {
				"dataType": "number",
				"style": "decimal",
				"useGrouping": true,
				"minimumFractionDigits": 0,
				"maximumFractionDigits": 2,
				"abbreviate": {},
				"nullString": "-"
			},
			"date": {
				"dataType": "date",
				"year": "numeric",
				"month": "numeric",
				"day": "numeric",
				"nullString": "-"
			}
		},
		"formatAliases": {
			"defaultAny": {
				"dataType": "any",
				"number": "shortDecimal",
				"date": "yyyy-mm-dd"
			},
			"standardDecimal": {
				"dataType": "number",
				"minimumFractionDigits": 0,
				"maximumFractionDigits": 2
			},
			"integer": {
				"dataType": "number",
				"minimumFractionDigits": 0,
				"maximumFractionDigits": 0
			},
			"shortDecimal": {
				"dataType": "number",
				"minimumFractionDigits": 2,
				"maximumFractionDigits": 2
			},
			"longDecimal": {
				"dataType": "number",
				"minimumFractionDigits": 3,
				"maximumFractionDigits": 3
			},
			"yyyy-mm-dd": {
				"dataType": "date",
				"year": "numeric",
				"month": "numeric",
				"day": "numeric"
			},
			"yyyy-mmmm-dd": {
				"dataType": "date",
				"year": "numeric",
				"month": "long",
				"day": "numeric"
			},
			"yyyy-mmm-dd": {
				"dataType": "date",
				"year": "numeric",
				"month": "short",
				"day": "numeric"
			},
			"yyyy-mmm-dd-hh-mm": {
				"dataType": "date",
				"year": "numeric",
				"month": "short",
				"day": "numeric",
				"hour": "numeric",
				"minute": "numeric"
			},
			"yy-mmm-dd": {
				"dataType": "date",
				"year": "2-digit",
				"month": "short",
				"day": "numeric"
			}
		},
		"colors": null,
		"colorPaletteName": "charts",
		"colorPalettes": {
			"areaChart": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"assetAllocations": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"charts": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"fixedIncomeStyleBox": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"lineChart": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"pieChart": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			],
			"stockStyleBox": [
				"#000",
				"#333",
				"#666",
				"#999",
				"#CCC",
				"#EEE"
			]
		},
		"fieldDefinitions": {
			"categoryId": {
				"requiredFields": []
			},
			"categoryName": {
				"requiredFields": []
			},
			"closePrice": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"debtEquityRatio": {
				"requiredFields": [],
				"format": "longDecimal"
			},
			"dividendYield": {
				"requiredFields": [],
				"format": "longDecimal"
			},
			"epsGrowth5Y": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"expenseRatio": {
				"requiredFields": [],
				"format": "standardDecimal"
			},
			"industryName": {
				"requiredFields": []
			},
			"name": {
				"requiredFields": []
			},
			"marketCap": {
				"requiredFields": [],
				"format": {
					"dataType": "number",
					"style": "decimal",
					"abbreviate": {
						"mode": "auto"
					}
				}
			},
			"priceBookRatio": {
				"requiredFields": [],
				"format": "standardDecimal"
			},
			"priceCurrency": {
				"requiredFields": []
			},
			"priceEarningsRatio": {
				"requiredFields": [],
				"format": "standardDecimal"
			},
			"priceSalesRatio": {
				"requiredFields": [],
				"format": "standardDecimal"
			},
			"rating": {
				"requiredFields": []
			},
			"returnD1": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnW1": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM0": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM1": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM3": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM6": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM12": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM36": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM60": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"returnM120": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"revenueGrowth3Y": {
				"requiredFields": [],
				"format": "shortDecimal"
			},
			"roettm": {
				"requiredFields": [],
				"format": "longDecimal"
			},
			"salesYield": {
				"requiredFields": [],
				"format": "longDecimal"
			},
			"sectorName": {
				"requiredFields": []
			}
		},
		"viewBreakpoints": {
			"small": 640,
			"medium": 1024,
			"large": 1440,
			"xlarge": 1920
		}
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(117), __webpack_require__(112), __webpack_require__(118),
	    __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar, config, instanceRegistry, util) {
	    'use strict';
	    var _bootstrapCallbacks = [];
	    var _hasInited = false;

	    reset();

	    return {
	        init: init,
	        reset: reset,
	        registerCallback: registerCallback
	    };

	    function init(options) {
	        if (_hasInited && window && !window.__karma__ && !window.__testing__) {
	            if (window.console) {
	                window.console.warn('Tried to call asterix.bootstrap.init multiple times');
	            }

	            return;
	        }

	        _hasInited = true;
	        options = options || {};
	        var appConfig = options.appConfig;
	        delete options.appConfig;
	        options = util.merge({}, {
	            appName: 'morningstarApp',
	            appConfig: null,
	            baseLabels: {},
	            baseSettings: {},
	            configOptions: {
	                dynamic: false
	            }
	        }, options || {});

	        options.appConfig = appConfig;
	        options.defaultConfig = morningstar.components._defaultConfig || {};

	        // todo(slind): we could merge options.appConfig with morningstar.components._appConfig, but not sure if that's behaviour that we want

	        if (!options.appConfig || !options.appConfig.components ||
	            Object.keys(options.appConfig.components).length === 0) {
	            options.configOptions.dynamic = true;
	        }

	        util.each(_bootstrapCallbacks, function(cb) {
	            cb(options);
	        });
	    }

	    function registerCallback(cb) {
	        _bootstrapCallbacks.push(cb);
	    }

	    function reset() {
	        _bootstrapCallbacks = [];
	        _bootstrapCallbacks.push(function defaultCb(options) {
	            config.init(options.appConfig ||
	                morningstar.components._appConfig ||
	                {components: {}}, options.defaultConfig, options.baseLabels, options.baseSettings, options.configOptions);
	            instanceRegistry.init();
	        });
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = morningstar;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112), __webpack_require__(9), __webpack_require__(119)], __WEBPACK_AMD_DEFINE_RESULT__ = function(config, util, ComponentInstance) {
	    'use strict';

	    var instanceRegistry = {
	        init: init,
	        reset: reset,
	        register: register,
	        get: get,
	        findAll: findAll,
	        find: find,
	        findByType: findByType,
	        all: all
	    };

	    var instances = {};

	    function init() {
	        reset();
	        var modulePaths = config.getModulePaths();
	        util.each(modulePaths, function(val, path) {
	            var instance = register(path);
	            //instance.getSettings();
	            //instance.getLabels();
	        });
	    }

	    function reset() {
	        util.each(instances, function(instance) {
	            instance.destroy();
	        });

	        instances = {};
	    }

	    function register(modulePath, options) {
	        if (instances.hasOwnProperty(modulePath)) {
	            return instances[modulePath];
	        }

	        if (config.canAddModulePathDynamically(modulePath) && options && options.type && !config.hasInstance(modulePath)) {
	            config.addInstance(modulePath, options);
	        } else if (!config.hasInstance(modulePath)) {
	            throw new Error('(instanceRegistry) tried to register a module path that does not exist in the config');
	        }

	        var component = new ComponentInstance(modulePath, instanceRegistry);
	        instances[modulePath] = component;
	        return component;
	    }

	    function all() {
	        return instances;
	    }

	    /** Find the first instance that matches the given search string. * can be used as "match all".
	     * @param search
	     */
	    function find(search) {
	        var regex = _getFindRegex(search);
	        for (var k in instances) {
	            if (instances.hasOwnProperty(k) && regex.test(k)) {
	                return instances[k];
	            }
	        }
	    }

	    /** Find all instances that match the given search string. * can be used as "match all".
	     * @param {string} search
	     */
	    function findAll(search) {
	        var regex = _getFindRegex(search);
	        return util.filter(instances, function(item, key) {
	            return regex.test(key);
	        });
	    }

	    function findByType(type) {
	        return util.filter(instances, function(instance, key) {
	            return instance.getModuleType() === type;
	        });
	    }

	    function _getFindRegex(search) {
	        if (!util.isString(search)) {
	            return new RegExp(search);
	        } else {
	            search = search.replace(/\./g, '\\.')
	            .replace(/\*/g, '.*');
	            return new RegExp('^' + search + '$');
	        }
	    }

	    function get() {
	        if (arguments.length === 2) {
	            var relativePath = util.isPlainObject(arguments[1]) ? null : arguments[1];

	            if (relativePath != null) {
	                var modulePath = util.componentPath.resolve(arguments[0], relativePath);
	                if (!instances[modulePath]) {
	                    throw new Error('(instanceRegistry) could not find any instance for: ' + modulePath);
	                }

	                return instances[modulePath];
	            } else {
	                return register(arguments[0], arguments[1]);
	            }
	        } else if (arguments.length === 1) {
	            if (!instances[arguments[0]]) {
	                throw new Error('(instanceRegistry) could not find any instance for: ' + arguments[0]);
	            }

	            return instances[arguments[0]];
	        } else {
	            throw new Error('(instanceRegistry) get expects 1 or 2 arguments');
	        }
	    }

	    return instanceRegistry;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112), __webpack_require__(9), __webpack_require__(113), __webpack_require__(1), __webpack_require__(3), __webpack_require__(120), __webpack_require__(121)], __WEBPACK_AMD_DEFINE_RESULT__ = function(config, util, formatting, validation, extend, ConfigEvaluator, ValidationState) {
	        'use strict';

	        var eventTypes = [
	            'activated',
	            'cancel',
	            'click',
	            'dataLoaded',
	            'deactivated',
	            'destroyed',
	            'editItem',
	            'labelChanged',
	            'labelsChanged',
	            'modelChanged',
	            'modelPropertyChanged',
	            'modelPropertyReset',
	            'modelReset',
	            'parameterChanged',
	            'parametersChanged',
	            'save',
	            'takeAction',
	            'valueChanged',
	            'validationReferenceChanged',
	            'validationStateChanged'
	        ];

	        // Special Events are handled as regular events even if isActive == false
	        var specialEvents = /^(activated|deactivated|destroyed)/;

	        function ComponentInstance(modulePath, instanceRegistry) {
	            this.isActive = false;
	            this.modulePath = modulePath;
	            this.instanceRegistry = instanceRegistry;

	            this.events = {};
	            this.listeners = [];

	            this.model = {};
	            this.parameters = {};

	            this.labelsCache = {};

	            this.isDestroyed = false;

	            this.eventPathPrevValue = {
	                parameterChanged: {},
	                modelPropertyChanged: {},
	                modelPropertyChanging: {},
	                modelPropertyReset: {}
	            };

	            this.unregisterFunctions = [];

	            this.resetValidationState();

	            var self = this;
	            util.each(eventTypes, function(type) {
	                self.events[type] = [];
	            });
	        }

	        ComponentInstance.prototype.hasParent = function hasParent() {
	            return this.getModulePath().indexOf('.') >= 0;
	        };

	        ComponentInstance.prototype.getOwnInstanceId = function getOwnInstanceId() {
	            var split = this.getModulePath().split('.');
	            return split[split.length - 1];
	        };

	        ComponentInstance.prototype.resetValidationState = function resetValidationState() {
	            this.validationState = new ValidationState(this);
	        };

	        ComponentInstance.prototype.getValidationState = function getValidationState() {
	            return this.validationState;
	        };

	        ComponentInstance.prototype.resetModel = function resetModel() {
	            this.model = {};
	            this.prevModel = null;
	            this.trigger('modelReset');
	        };

	        ComponentInstance.prototype.destroy = function destroy() {
	            var self = this;

	            this.trigger('destroyed');
	            this.events = {};
	            util.each(this.listeners, function(listener) {
	                if (!listener.instance.isDestroyed && listener.instance != self) {
	                    listener.instance.off(listener.eventName, listener.callback);
	                }
	            });

	            util.each(this.unregisterFunctions, function(f) {
	                f();
	            });

	            this.listeners.length = 0;
	            this.isDestroyed = true;
	        };

	        /**
	         * Adds a listener for eventName.
	         * @param eventName
	         * @param callback
	         * @returns {Function} - Returns a function that can be called with no arguments to unregister the listener.
	         */
	        ComponentInstance.prototype.on = function on(eventName, callback) {
	            var self = this;
	            var split;
	            if ((split = eventName.split(':')).length === 2 && this.eventPathPrevValue[split[0]]) {
	                if (!this.eventPathPrevValue[split[0]][split[1]]) {
	                    this.eventPathPrevValue[split[0]][split[1]] = {
	                        prevValue: null,
	                        getValue: util.parse(split[1])
	                    };
	                }

	                if (!this.events.hasOwnProperty(eventName)) {
	                    this.events[eventName] = [];
	                }
	            }

	            //if event is not a standard asterix event
	            if (!this.events.hasOwnProperty(eventName)) {
	                var allowedEvents = morningstar.asterix.meta.get(this.getModuleType(), 'allowedEvents');
	                //if event is defined as allowed-event in component settings
	                if (allowedEvents && allowedEvents.indexOf(eventName) !== -1) {
	                    this.events[eventName] = [];
	                } else {
	                    throw new Error('(' + this.modulePath + ') Unrecognized event: ' + eventName);
	                }
	            }

	            this.events[eventName].push(callback);
	            return function unregister() {
	                self.off(eventName, callback);
	            };
	        };

	        ComponentInstance.prototype.off = function off(eventName, callback) {
	            if (!this.events.hasOwnProperty(eventName)) {
	                // already off'd
	                return;
	            }

	            if (this.events.hasOwnProperty(eventName) && this.events[eventName].indexOf(callback) >= 0) {
	                this.events[eventName].splice(this.events[eventName].indexOf(callback), 1);
	            }
	        };

	        ComponentInstance.prototype.trigger = function trigger(eventName, args) {
	            var self = this;
	            var orCb = {
	                or: function(callback) {
	                    if (!self.events[eventName] || self.events[eventName].length === 0 || !self.isActive) {
	                        callback();
	                    }
	                }
	            };

	            // Special Events are handled as regular events even if isActive == false
	            var isSpecialEvent = specialEvents.test(eventName);

	            if (util.isUndefined(args)) {
	                args = [];
	            }

	            if (!this.events[eventName] && !isSpecialEvent) {
	                return orCb;
	            }

	            if (self.isActive || isSpecialEvent) {
	                util.each(this.events[eventName], function(callback) {
	                    callback.apply(self, args);
	                });
	            }

	            return orCb;
	        };

	        ComponentInstance.prototype.hasListener = function hasListener(eventName) {
	            return this.events.hasOwnProperty(eventName) && this.events[eventName].length > 0;
	        };

	        ComponentInstance.prototype.listen = function listen(instanceToListenTo, eventName, callback) {
	            var listener = util.any(this.listeners, function(obj) {
	                return obj.instance === instanceToListenTo && obj.eventName === eventName;
	            });
	            if (!listener) {
	                this.listeners.push({
	                    instance: instanceToListenTo,
	                    eventName: eventName,
	                    callback: callback
	                });
	                instanceToListenTo.on(eventName, callback);
	            }
	        };

	        ComponentInstance.prototype.getModulePath = function getModulePath() {
	            return this.modulePath;
	        };

	        ComponentInstance.prototype.getModuleType = function getModuleType() {
	            return config.getComponentType(this.getModulePath());
	        };

	        ComponentInstance.prototype.hasParent = function hasParent() {
	            return this.getModulePath().indexOf('.') >= 0;
	        };

	        ComponentInstance.prototype.getOwnInstanceId = function getOwnInstanceId() {
	            var split = this.getModulePath().split('.');
	            return split[split.length - 1];
	        };

	        ComponentInstance.prototype.getValue = function getValue() {
	            return this.value;
	        };

	        ComponentInstance.prototype.setValue = function setValue(value) {
	            this.value = value;
	            this.trigger('valueChanged', [value]);
	        };

	        ComponentInstance.prototype.getModel = function getModel() {
	            return this.model;
	        };

	        ComponentInstance.prototype.setModel = function setModel(model) {
	            if (util.isEqual(model, this.prevModel)) {
	                return;
	            }

	            this.prevModel = util.isObject(model) ? extend(true, util.isArray(model) ? [] : {}, model) : model;
	            this._triggerPathEvents('modelPropertyChanging', model);
	            this.model = model;
	            this.trigger('modelChanged', [model]);
	            this._triggerPathEvents('modelPropertyChanged', model);
	        };

	        ComponentInstance.prototype.setModelProperty = function setModelProperty(propertyName, value) {
	            var func = util.parse(propertyName);

	            if (value !== null && util.isEqual(func(this.prevModel), value)) {
	                return;
	            }

	            this.prevModel = this.prevModel || {};
	            func.assign(this.prevModel, util.isObject(value) ? extend(true, util.isArray(value) ? [] : {}, value) : value);
	            func.assign(this.model, value);
	            this._triggerPathEvents('modelPropertyChanging', this.model, propertyName);

	            this.trigger('modelChanged', [this.model]);
	            this.trigger('modelPropertyChanged', [value, propertyName]);
	            this._triggerPathEvents('modelPropertyChanged', this.model, propertyName);

	            if (value === null) {
	                this.trigger('modelPropertyReset', [value, propertyName]);
	                this._triggerPathEvents('modelPropertyReset', this.model, propertyName);
	            }
	        };

	        ComponentInstance.prototype.getModelProperty = function getModelProperty(propertyName) {
	            return util.parse(propertyName)(this.model);
	        };

	        ComponentInstance.prototype.validate = function validate(value) {
	            this.validator = validation.getValidator(this._getEvaluatedValidationRulesAndListenForChanges());
	            if (!this.validator) {
	                return;
	            }

	            var validationState = this.validator.validate(value);
	            return validationState;
	        };

	        ComponentInstance.prototype._isValid = function _isValid(validationState) {
	            return !util.any(validationState, function(v) {
	                return !v.returnValue;
	            });
	        };

	        ComponentInstance.prototype._triggerPathEvents = function _triggerPathEvents(eventTypeName, fullObj, matchPrefix) {
	            var self = this;
	            if (matchPrefix && matchPrefix.indexOf('.') !== -1) {
	                matchPrefix = matchPrefix.substring(0, matchPrefix.indexOf('.'));
	            }

	            util.each(this.eventPathPrevValue[eventTypeName], function(v, path) {
	                if (matchPrefix && path.indexOf(matchPrefix) !== 0) {
	                    return;
	                }

	                var newValue = v.getValue(fullObj);

	                if (!util.isEqual(newValue, v.prevValue)) {
	                    if (util.isObject(newValue)) {
	                        v.prevValue = extend(true, util.isArray(newValue) ? [] : {}, newValue);
	                    } else {
	                        v.prevValue = newValue;
	                    }

	                    self.trigger(eventTypeName + ':' + path, [newValue]);
	                } else {
	                }
	            });
	        };

	        ComponentInstance.prototype._getEvaluatedValidationRulesAndListenForChanges = function _getEvaluatedValidationRulesAndListenForChanges() {
	            var self = this;
	            var validation = extend(true, {}, this.getSettings()._validation);
	            var evaluator = new ConfigEvaluator(this.modulePath, self.instanceRegistry);
	            var result = evaluator.evaluate(validation);
	            util.each(result.references, function(reference) {
	                self.listen(reference.instance, reference.eventType, function(val) {
	                    self.trigger('validationReferenceChanged', [reference, val]);
	                });
	            });

	            return result.evaluated;
	        };

	        ComponentInstance.prototype.getSettings = function getSettings() {
	            var result = config.getSettings(this.modulePath);
	            if (result.fields) {
	                result.fields = util.field.applyDefinitionsAndAliasesToMany(result.fields, result.fieldDefinitions, result.formatAliases);
	            }

	            return result;
	        };

	        ComponentInstance.prototype.getLabels = function getLabels() {
	            // if we've already evaluated and cached labels for this languageId, return the cached version
	            if (this.labelsCache[this.getSettings().languageId]) {
	                return this.labelsCache[this.getSettings().languageId];
	            }

	            return this.labelsCache[this.getSettings().languageId] = this._getEvaluatedLabelsAndListenForChanges();
	        };

	        ComponentInstance.prototype._getEvaluatedLabelsAndListenForChanges = function _getEvaluatedLabelsAndListenForChanges() {
	            var self = this;
	            var labels = config.getLabels(this.modulePath, this.getSettings().languageId);
	            var evaluator = new ConfigEvaluator(this.modulePath, this.instanceRegistry);
	            var result = evaluator.evaluate(util.merge({}, labels), {
	                model: true,
	                value: true,
	                settings: true,
	                parameters: true
	            });
	            if (!this.isListeningToLabelReferences) {
	                this.isListeningToLabelReferences = true;
	                util.each(result.references, function(reference) {
	                    self.unregisterFunctions.push(reference.listen(function() {
	                        var cached = self.labelsCache[self.getSettings().languageId];
	                        evaluator = new ConfigEvaluator(self.modulePath, self.instanceRegistry);
	                        var nodeRes = evaluator.evaluate(reference.source.expression, {
	                            model: true,
	                            value: true,
	                            settings: true,
	                            parameters: true
	                        });
	                        util.parse(reference.source.path).assign(cached, nodeRes.evaluated);
	                        self.trigger('labelChanged', [nodeRes.evaluated, reference.source.path]);
	                    }));
	                });
	            }

	            return result.evaluated;
	        };

	        ComponentInstance.prototype.getFormatter = function getFormatter() {
	            var format, labels, currencyId, formatAliases;

	            format = config.getSetting(this.modulePath, 'format');
	            formatAliases = config.getSetting(this.modulePath, 'formatAliases');
	            labels = config.getLabels(this.modulePath, this.getSettings().languageId);
	            currencyId = config.getSetting(this.modulePath, 'currencyId');

	            var abbreviations = {
	                thousands: labels.thousands,
	                millions: labels.millions,
	                billions: labels.billions,
	                trillions: labels.trillions
	            };

	            // todo(slind): could add language-dependent nullString

	            return formatting.getFormatter(this.getSettings().languageId, format, formatAliases, abbreviations, currencyId);
	        };

	        ComponentInstance.prototype._cloneParameters = function _cloneParameters(parameters) {
	            return util.isObject(parameters) ?
	                extend(true, util.isArray(parameters) ? [] : {}, parameters, function mergeCustomizer(a, b, key) {
	                    if (util.isFunction(a) && !b) {
	                        return a;
	                    }

	                    if (util.isFunction(b)) {
	                        return b;
	                    }
	                }) : parameters;
	        };

	        ComponentInstance.prototype.setParameters = function setParameters(parameters) {
	            if (util.isEqual(parameters, this.prevParameters)) {
	                return;
	            }

	            this.parameters = parameters;
	            this.prevParameters = this._cloneParameters(parameters);

	            this.trigger('parametersChanged', [this.parameters]);
	            this._triggerPathEvents('parameterChanged', parameters);
	        };

	        ComponentInstance.prototype.getParameters = function getParameters() {
	            return this.parameters;
	        };

	        ComponentInstance.prototype.setParameter = function setParameter(propertyName, value) {
	            var func = util.parse(propertyName);
	            if (util.isEqual(func(this.prevParameters), value)) {
	                return;
	            }

	            func.assign(this.parameters, value);
	            this.prevParameters = this._cloneParameters(this.parameters);
	            this.trigger('parameterChanged', [value, propertyName]);
	            this.trigger('parameterChanged:' + propertyName, [value]);
	        };

	        ComponentInstance.prototype.getParameter = function getParameter(propertyName) {
	            return util.parse(propertyName)(this.parameters);
	        };

	        ComponentInstance.prototype.getDefaultColorPalette = function getDefaultColorPalette() {
	            return this.getSettings().colors || this.getSettings().colorPalettes[this.getSettings().colorPaletteName];
	        };

	        ComponentInstance.prototype.activate = function activate() {
	            this.isActive = true;
	            this.trigger('activated');
	        };

	        ComponentInstance.prototype.deactivate = function deactivate() {
	            this.isActive = false;
	            this.trigger('deactivated');
	        };

	        /**
	         * Deprecated! Use getRelative instead ("findRelative" is inconsistent with what it actually does...)
	         * @param relativePath
	         * @returns {*}
	         */
	        ComponentInstance.prototype.findRelative = function findRelative(relativePath) {
	            return this.instanceRegistry.get(this.getModulePath(), relativePath);
	        };

	        ComponentInstance.prototype.getRelative = function getRelative(relativePath) {
	            return this.instanceRegistry.get(this.getModulePath(), relativePath);
	        };

	        return ComponentInstance;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function(config, util) {
	    'use strict';

	    var singleMustacheRegex = new RegExp('\\{\\{\\_\\s*(.*?)\\s*\\_\\}\\}');
	    var multiMustacheRegex = new RegExp('\\{\\{\\_\\s*(.*?)\\s*\\_\\}\\}', 'g');
	    var exactlyOneMustacheRegex = new RegExp('^\\{\\{\\_\\s*([^}]*?)\\s*\\_\\}\\}$');
	    var baseRegex = '\\((.*?)\\)(?:\\.([^+\\-*\\/\\s|()]*))?(?:\\|(number|date)(?:\\(([^)]*)\\))?)?';
	    var regexes = {
	        settings: new RegExp('settings' + baseRegex, 'g'),
	        model: new RegExp('model' + baseRegex, 'g'),
	        labels: new RegExp('labels' + baseRegex, 'g'),
	        parameters: new RegExp('parameters' + baseRegex, 'g'),
	        value: new RegExp('value' + baseRegex, 'g')
	    };

	    function ConfigEvaluator(modulePath, instanceRegistry) {
	        this.modulePath = modulePath;
	        this.instanceRegistry = instanceRegistry;
	    }

	    ConfigEvaluator.prototype.evaluate = function evaluate(obj, evaluationTypes) {
	        this.references = [];
	        this.evaluationTypes = evaluationTypes || {
	                settings: true,
	                model: true,
	                labels: true,
	                parameters: true,
	                value: true
	            };
	        this.obj = obj;
	        var evaluated = this._traverse(obj);

	        return {
	            evaluated: evaluated,
	            references: this.references
	        };
	    };

	    ConfigEvaluator.prototype._hasMustache = function _hasMustache(str) {
	        return singleMustacheRegex.test(str);
	    };

	    ConfigEvaluator.prototype._evaluateString = function _evaluateString(str, path) {
	        var self = this;
	        if (!this._hasMustache(str)) {
	            return str;
	        }

	        var source = {
	            expression: str,
	            path: path
	        };
	        var result = null;
	        if (exactlyOneMustacheRegex.test(str)) {
	            // exactly one match (this may return other types than string)
	            var match = str.match(exactlyOneMustacheRegex);
	            result = self._evaluateStringExpressions(match[1], match[0], source);
	        } else {
	            // multiple mustaches/string composition (will always return a string)
	            result = str.replace(multiMustacheRegex, function(whole, inner) {
	                return self._evaluateStringExpressions(inner, whole, source);
	            });
	        }

	        return result;
	    };

	    ConfigEvaluator.prototype._evaluateStringExpressions = function _evaluateStringExpressions(str, mustache, source) {
	        this.hasStringValue = false;
	        var original = str;
	        var self = this;

	        util.each(this.evaluationTypes, function(type, key) {
	            str = self._evaluateStringExpressionType(str, key, source, mustache, function(instance) {
	                return instance['get' + util.string.firstUpperCase(key)]();
	            });
	        });

	        return str === original ? mustache : (!this.hasStringValue ? this._eval(str) : str);
	    };

	    ConfigEvaluator.prototype._eval = function _eval(str) {
	        return this._isJsonSerialized(str) ? JSON.parse(str) : eval(str);
	    };

	    ConfigEvaluator.prototype._isJsonSerialized = function _isJsonSerialized(str) {
	        return str.indexOf('{') === 0 || str.indexOf('[') === 0;
	    };

	    ConfigEvaluator.prototype._evaluateStringExpressionType = function _evaluateStringExpressionType(str, type, source, mustache, instanceCallback) {
	        var self = this;
	        str = str.replace(regexes[type], function(match, relativeModulePath, propsExpression, formatType, format) {
	            return self._getReplacementsRecursively(instanceCallback, relativeModulePath, propsExpression, formatType, format, type, source, mustache);
	        });

	        return str;
	    };

	    ConfigEvaluator.prototype._getReplacementsRecursively = function _getReplacementsRecursively(instanceCallback, relativeModulePath, propsExpression,
	                                                                                                 formatType, format, type, source, mustache) {
	        var referencedInstance;
	        try {
	            referencedInstance = this.instanceRegistry.get(this.modulePath, relativeModulePath);
	        } catch (ex) {
	            this.hasStringValue = true;
	            util.log.error('ConfigEvaluator failed to evaluate expression', mustache, 'from component', this.modulePath);
	            return mustache;
	        }

	        var self = this;

	        var value;
	        if (!referencedInstance) {
	            throw new Error('ConfigEvaluator could not find referenced instance: ' + this.modulePath + ', ' +
	                relativeModulePath);
	        }
	        var originalReference = {
	            type: type,
	            instance: referencedInstance,
	            refPath: propsExpression || '',
	            source: source,
	            listen: this._createListener(type, propsExpression || '', referencedInstance),
	            assign: this._createAssigner(type, propsExpression || '', referencedInstance),
	            eventType: this._getEventType(type, propsExpression || ''),
	            mustache: mustache,
	            modulePath: this.modulePath,
	            relativeModulePath: relativeModulePath,
	            formatType: formatType,
	            format: format
	        };
	        value = instanceCallback(referencedInstance);
	        value = propsExpression ? util.parse(propsExpression)(value) : value;

	        if (this._hasMustache(value) && type !== 'model') {
	            // returned value has a mustache
	            // in the returned references, we skip straight to the end of the "mustache chain"
	            var relative = util.componentPath.relative(self.modulePath, referencedInstance.getModulePath());
	            var evaluator = new ConfigEvaluator(referencedInstance.getModulePath(), this.instanceRegistry);
	            var result = evaluator.evaluate(value);
	            util.each(result.references, function(v) {
	                // replace modulePath, source and source expression for the reference and base relative module paths from self.modulePath
	                var relativeModulePath = !relative ? v.relativeModulePath :
	                    util.componentPath.resolve(relative, v.relativeModulePath);
	                var replacementMustache = v.mustache.replace('(' + v.relativeModulePath + ')', '(' +
	                    relativeModulePath + ')');
	                if (formatType) {
	                    // add the calling end of the chain's format to the mustache
	                    var formatString = '|' + formatType + (format ? '(' + format + ')' : '');
	                    replacementMustache = replacementMustache.replace(/(?:\|.*?)?(\s*\_\}\})/, function(match, end) {
	                        return formatString + end;
	                    });
	                }

	                v.modulePath = self.modulePath;
	                v.source = originalReference.source;
	                v.source.expression = v.source.expression.replace(mustache, replacementMustache);
	            });
	            this.references = this.references.concat(result.references);
	            value = result.evaluated;
	        } else {
	            // no mustache in the returned value -- use original reference
	            this.references.push(originalReference);
	        }

	        originalReference.value = value;
	        value = this._getFormatted(value, this.instanceRegistry.get(this.modulePath), formatType, format);
	        return this.hasStringValue === true ? value : JSON.stringify(value);
	    };

	    ConfigEvaluator.prototype._getEventType = function _getEventType(type, refPath) {
	        switch (type) {
	            case 'parameters':
	                if (refPath) {
	                    return 'parameterChanged:' + refPath;
	                } else {
	                    return 'parametersChanged';
	                }
	            case 'model':
	                if (refPath) {
	                    return 'modelPropertyChanged:' + refPath;
	                } else {
	                    return 'modelChanged';
	                }
	            case 'value':
	                if (refPath) {
	                    //throw new Error('refPath for reference of type "value" in ConfigEvaluator is not implemented yet');
	                    return 'valuePropertyChanged:' + refPath;
	                } else {
	                    return 'valueChanged';
	                }
	        }

	        return null;
	    };

	    ConfigEvaluator.prototype._createAssigner = function _createAssigner(type, refPath, instance) {
	        return function assign(value) {
	            switch (type) {
	                case 'parameters':
	                    if (!refPath) {
	                        instance.setParameters(value);
	                    } else {
	                        instance.setParameter(refPath, value);
	                    }
	                    break;
	                case 'model':
	                    if (!refPath) {
	                        instance.setModel(value);
	                    } else {
	                        instance.setModelProperty(refPath, value);
	                    }
	                    break;
	            }
	        };
	    };

	    ConfigEvaluator.prototype._createListener = function _createListener(type, refPath, instance) {
	        var self = this;
	        return function(onChangeCallback) {
	            var listenerType = self._getEventType(type, refPath);
	            if (listenerType == null) {
	                return util.noop;
	            }

	            return instance.on(listenerType, onChangeCallback);
	        };
	    };

	    ConfigEvaluator.prototype._getFormatted = function _getFormatted(value, instance, formatType, format) {
	        if (formatType == null) {
	            if (util.isString(value)) {
	                this.hasStringValue = true;
	            }

	            return value;
	        }

	        this.hasStringValue = true;
	        var formatter = instance.getFormatter();
	        if (formatType === 'number') {
	            value = formatter.number(value, {
	                formatString: format
	            });
	        } else if (formatType === 'date') {
	            value = formatter.date(value, {
	                formatString: format
	            });
	        }

	        return value;
	    };

	    ConfigEvaluator.prototype._traverse = function _traverse(obj, path) {
	        path = path || '';
	        var self = this;
	        if (util.isString(obj)) {
	            return self._evaluateString(obj, path);
	        } else if (util.isPlainObject(obj) || util.isArray(obj)) {
	            var originalPath = path;
	            util.each(obj, function(value, prop) {
	                path = originalPath ? (originalPath + '.' + prop) : prop;
	                obj[prop] = self._traverse(value, path);
	            });
	        }

	        return obj;
	    };

	    return ConfigEvaluator;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(util, extend) {

	        var _errorsOnlyPredicate = function _errorsOnlyPredicate(result) {
	            return result.returnValue === false;
	        };

	        function ValidationState(instance) {
	            this._instance = instance;
	            this._state = {};
	            this._children = {};
	            this._calculcatedMergedState = {};
	        }

	        ValidationState.prototype.getState = function getState() {
	            return this._state;
	        };

	        ValidationState.prototype.setState = function setState(state) {
	            if (util.isEqual(this.getState(), state)) {
	                return;
	            }

	            this._state = state || {};
	            this.triggerUpdated();
	        };

	        ValidationState.prototype.triggerUpdated = function triggerUpdated() {
	            if (this._instance.hasParent()) {
	                // todo(slind): could refactor this so that ComponentInstance gets hooked up with its child instances (rather than handling that logic in here)
	                this._instance.getRelative('_').getValidationState().setChild(this._instance.getOwnInstanceId(), this);
	            }

	            this._calculateMergedState();
	            this._instance.trigger('validationStateChanged', []);
	            if (this._instance.hasParent()) {
	                this._instance.getRelative('_').getValidationState().triggerUpdated();
	            }
	        };

	        ValidationState.prototype.getChildren = function getChildren() {
	            return this._children;
	        };

	        ValidationState.prototype.setChild = function setChild(childName, childValidationState) {
	            this._children[childName] = childValidationState;
	        };

	        ValidationState.prototype.getNamespacedKey = function getNamespacedKey(key) {
	            return [this._instance.getModulePath(), key].join('_');
	        };

	        ValidationState.prototype._calculateMergedState = function _calculateMergedState() {
	            var results = this.getNamespacedState();
	            util.each(this._children, function(child) {
	                util.each(child.getMergedStateFiltered(), function(rule, key) {
	                    results[key] = rule;
	                });
	            });

	            this._calculcatedMergedState = results;
	        };

	        ValidationState.prototype.getMergedStateFiltered = function getMergedStateFiltered(predicate) {
	            var results = extend({}, this._calculcatedMergedState);
	            if (!predicate) {
	                return results;
	            }

	            util.each(results, function(rule, key) {
	                if (!predicate(rule)) {
	                    delete results[key];
	                }
	            });

	            return results;
	        };

	        ValidationState.prototype.getNamespacedState = function getNamespacedState() {
	            var self = this;
	            var results = {};
	            util.each(this.getState(), function(result, key) {
	                result = extend(true, {}, result);
	                result.label = self._instance.getLabels()[result.rule.labelKey] || result.rule.labelKey;
	                result.instanceId = self._instance.getOwnInstanceId();
	                results[self.getNamespacedKey(key)] = result;
	            });

	            return results;
	        };

	        ValidationState.prototype.isValid = function isValid() {
	            var mergedState = this.getMergedStateFiltered(_errorsOnlyPredicate);
	            return Object.keys(mergedState).length === 0;
	        };

	        return ValidationState;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function(each) {
	    'use strict';
	    var meta = {};

	    return {
	        register: function register(type, key, value) {
	            if (!meta[type]) {
	                meta[type] = {};
	            }

	            meta[type][key] = value;

	            return this;
	        },
	        get: function get(type, key) {
	            if (!key) {
	                return meta[type];
	            }

	            return meta[type] ? meta[type][key] : undefined;
	        },
	        findTypesWhere: function findTypesWhere(key, value) {
	            var results = [];
	            each(meta, function(obj, type) {
	                if (obj[key] === value) {
	                    results.push(type);
	                }
	            });

	            return results;
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(117)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar) {
	    'use strict';

	    /**
	     * To append morningstar component directive to client's container
	     * @param {string} morningstarComponentId - the component instance name
	     * @param {object} container - the container object (e.g. document.getElementById('containerId'))
	     * @return {object} - component instance
	     */
	    function init(morningstarComponentId, params) {
	        var instanceConfig = morningstar.asterix.config.getInstanceConfig(morningstarComponentId);
	        if (instanceConfig) {
	            var componentType = morningstar.asterix.util.string.dashCase(instanceConfig.type);
	            if (/^ec-/.test(componentType)) { // mean it is a EC component will build the tag
	                var componentNode = document.createElement(componentType);
	                componentNode.setAttribute('mstar-component-id', morningstarComponentId);
	                if (morningstar.asterix.util.isDomElement(params.container)) {
	                    params.container.appendChild(componentNode);
	                } else {
	                    morningstar.asterix.util.log.debug('params.container is not a object.');
	                }
	                return morningstar.asterix.instanceRegistry.get(morningstarComponentId);
	            } else if (/^markets-components-/.test(componentType)) {
	                return morningstar.components[componentType].createComponent({
	                    element: params.container,
	                    initialConfiguration: params.initialConfiguration || {
	                        component: {
	                            configuration: instanceConfig.settings,
	                            callbacks: instanceConfig.settings.callbacks
	                        }
	                    }
	                });
	            }
	        } else {
	            morningstar.asterix.util.log.debug('Invalid morningstar component instance with id:' + morningstarComponentId);
	            return null;
	        }
	    }

	    return {
	        init: init
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(22), __webpack_require__(27), __webpack_require__(14), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(each, isEqual, isString, isFunction) {
	    var tokens, tokenChangedListeners;

	    reset();

	    return {
	        getToken: getToken,
	        setToken: setToken,
	        onTokenChanged: onTokenChanged,
	        reset: reset
	    };

	    function getToken(key) {
	        if (!key || !isString(key)) {
	            throw new Error('getToken expects a string key');
	        }

	        return tokens[key];
	    }

	    function setToken(key, value) {
	        if (!key || !isString(key)) {
	            throw new Error('setToken expects a string key');
	        }

	        if (isEqual(tokens[key], value)) {
	            return;
	        }

	        tokens[key] = value;
	        each(tokenChangedListeners[key] || [], function iterateTokenChangedListeners(callback) {
	            callback(tokens[key]);
	        });
	    }

	    function onTokenChanged(key, callback) {
	        if (!key || !isString(key)) {
	            throw new Error('onTokenChanged expects a string key');
	        }

	        if (!isFunction(callback)) {
	            throw new Error('onTokenChanged expects a callback of type function');
	        }

	        if (!tokenChangedListeners[key]) {
	            tokenChangedListeners[key] = [];
	        }

	        tokenChangedListeners[key].push(callback);

	        return function off() {
	            tokenChangedListeners[key].splice(tokenChangedListeners[key].indexOf(callback), 1);
	        };
	    }

	    function reset() {
	        tokens = {};
	        tokenChangedListeners = {};
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** asterix-core.js
 **/